export default {
  "nav_signin": "Prijava",
  "nav_account": "Račun",
  "nav_signout": "Odjava",
  "hero_title": "Pametne Digitalne Rešitve",
  "hero_title_line1": "Infinity Business — Pametne",
  "hero_title_line2": "Digitalne rešitve",
  "hero_subtitle": "Spoznajte RisTA, vašega digitalnega partnerja",
  "hero_cta": "Pogovorite se z RisTA",
  "hero_cta2": "Ogled storitev",
  "b2b_title": "Poslovne Rešitve (B2B)",
  "p2p_title": "Osebne Rešitve (P2P)",
  "b2b_desc": "Spletni, mobilni, programski razvoj, gostovanje, dizajn in oglaševanje",
  "p2p_desc": "Kripto izobraževanje, naložbena orodja, organizacija, prevajanje, brendiranje, domene",
  "services_title": "Naše storitve",
  "services_subtitle": "Od spletnih rešitev do naložbenih orodij. RisTA vas vodi.",
  "cta_title": "Pripravljeni ustvariti nekaj neverjetnega?",
  "cta_subtitle": "Pogovorite se z RisTA za personalizirano ponudbo.",
  "about": "O nas",
  "contact": "Kontakt",
  "privacy": "Zasebnost",
  "blog": "Blog",
  "donate": "Doniraj",
  "booking": "Rezerviraj termin",
  "login_title": "Dobrodošli nazaj",
  "register_title": "Ustvarite račun",
  "login_subtitle": "Prijavite se v svoj Infinity Business račun",
  "register_subtitle": "Pridružite se Infinity Businessu danes",
  "auth0_btn": "Nadaljuj z Auth0",
  "or_email": "ali nadaljujte z e-pošto",
  "email": "E-poštni naslov",
  "password": "Geslo",
  "full_name": "Polno ime",
  "signin_btn": "Prijava",
  "register_btn": "Ustvari račun",
  "no_account": "Nimate računa?",
  "have_account": "Že imate račun?",
  "create_one": "Ustvarite ga",
  "sign_in": "Prijavite se",
  "pricing_title": "Izberite svoj načrt",
  "pricing_subtitle": "Povečajte svoje poslovanje. Vsi načrti vključujejo RisTA.",
  "pay_stripe": "Plačaj s Stripe",
  "pay_mypos": "Plačaj z myPOS",
  "pay_crypto": "Plačaj s kriptom",
  "free_plan": "Trenutni brezplačni načrt",
  "most_popular": "Najbolj priljubljen",
  "dashboard_title": "Moj račun",
  "profile": "Profil",
  "security": "Varnost (2FA)",
  "subscription": "Naročnina",
  "upgrade": "Nadgradi",
  "change_plan": "Zamenjaj načrt",
  "twofa_title": "Dvostopenjska avtentikacija",
  "setup_2fa": "Nastavi 2FA",
  "disable_2fa": "Onemogoči 2FA",
  "payment_success": "Plačilo uspešno!",
  "payment_cancel": "Plačilo preklicano",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Vse pravice pridržane.",
  "about_title": "O Infinity Business",
  "contact_title": "Kontaktirajte nas",
  "privacy_title": "Politika zasebnosti",
  "send_message": "Pošlji sporočilo",
  "trade_title": "Mi trgujemo za vas",
  "trade_desc": "Profesionalne storitve kripto trgovanja. Pogovorite se z nami in rezervirajte termin.",
  "back_home": "Nazaj na domačo stran",
  "loading": "Nalaganje...",
  "save": "Shrani",
  "session_expired": "Vaša seja je potekla. Prosimo, prijavite se znova.",
  "nav_services": "Storitve",
  "nav_portal": "Portal",
  "nav_credits": "Krediti",
  "hero_online": "Na spletu",
  "hero_digital_partner": "Digitalni partner",
  "business_solutions": "Poslovne rešitve",
  "personal_solutions": "Osebne rešitve",
  "enterprise_desc": "Profesionalne digitalne storitve za rast vašega podjetja.",
  "personal_desc": "Pametna investicijska orodja in izobraževanje za osebno rast.",
  "services_hero_title": "Naše storitve",
  "services_hero_desc": "Od osnovnih spletnih strani do naprednih pametnih rešitev. Zagotavljamo digitalno odličnost.",
  "get_started": "Začnite",
  "get_a_quote": "Pridobite ponudbo",
  "free_seo_audit": "Brezplačen SEO pregled",
  "ready_to_start": "Pripravljeni za začetek?",
  "ready_to_build": "Pripravljeni ustvariti nekaj izjemnega?",
  "ready_to_build_sub": "Pogovorite se z RisTA za personalizirano ponudbo.",
  "trusted_worldwide": "Zaupanje po svetu",
  "chat_placeholder": "Vnesite sporočilo...",
  "chat_suggested_1": "Potrebujem spletno stran",
  "chat_suggested_2": "Povejte mi o storitvah",
  "chat_suggested_3": "Želim pametno storitev",
  "chat_suggested_4": "Pridobi oceno cene",
  "trust_platform": "Zaupanja vredna platforma",
  "trust_security": "Poslovna varnost",
  "trust_ai": "Pametna Tehnologija",
  "trust_global": "Globalni doseg",
  "back_to_home": "Nazaj na začetek",
  "continue_google": "Nadaljuj z Googlom",
  "continue_facebook": "Nadaljuj s Facebookom",
  "continue_github": "Nadaljuj z GitHubom",
  "or_continue_email": "ali nadaljuj z emailom",
  "two_factor_auth": "Dvofaktorska avtentikacija",
  "enter_2fa_code": "Vnesite kodo iz aplikacije za avtentikacijo",
  "verify_btn": "Preveri kodo",
  "verifying": "Preverjanje...",
  "use_different_account": "Uporabi drug račun",
  "session_expired_msg": "Vaša seja je potekla zaradi neaktivnosti.",
  "nav_home": "Domov",
  "nav_back": "Nazaj",
  "my_account": "Moj račun",
  "sign_out": "Odjava",
  "client_portal": "Portal za stranke",
  "your_projects": "Vaši projekti",
  "your_invoices": "Vaši računi",
  "projects": "Projekti",
  "invoices_tab": "Računi",
  "milestones": "Mejniki",
  "messages": "Sporočila",
  "no_projects": "Še ni projektov.",
  "no_invoices": "Še ni računov.",
  "no_messages": "Še ni sporočil.",
  "type_message": "Vnesite sporočilo...",
  "back_to_projects": "Nazaj na projekte",
  "budget_label": "Proračun",
  "progress_label": "Napredek",
  "service_label": "Storitev",
  "portal_locked_desc": "Portal je na voljo odobrenim strankam.",
  "contact_to_start": "Kontaktirajte nas",
  "quick_web_dev": "Spletni razvoj",
  "quick_mobile": "Mobilna aplikacija",
  "quick_crypto": "Kripto izobraževanje",
  "quick_get_quote": "Pridobi ponudbo",
  "quick_tell_more": "Povejte več",
  "quick_have_project": "Imam projekt",
  "quick_submit": "Pošlji zahtevo",
  "get_cost_estimate": "Ocena stroškov",
  "choose_plan": "Izberite načrt",
  "choose_plan_desc": "Rast vašega podjetja s pravim načrtom.",
  "current_free_plan": "Trenutni brezplačni načrt",
  "svc_ecommerce_label": "E-trgovina / Spletna trgovina",
  "svc_ecommerce_desc": "Popolne spletne trgovine z integracijo plačil",
  "svc_ecommerce_price": "Od €799",
  "svc_seo_label": "SEO in digitalni marketing",
  "svc_seo_desc": "Optimizacija iskalnikov in strategija rasti",
  "svc_seo_price": "Od €299/mesec",
  "svc_hosting_label": "Upravljano gostovanje",
  "svc_hosting_desc": "Varna, hitra in zanesljiva gostovalna infrastruktura",
  "svc_hosting_price": "Od €29/mesec",
  "svc_advertising_label": "Digitalno oglaševanje",
  "svc_advertising_desc": "PPC, družbeni oglasi in trženje uspešnosti",
  "svc_advertising_price": "Od €499/mesec",
  "svc_trading_label": "Trgovalno svetovanje",
  "svc_trading_desc": "Strokovne seje za trgovalno strategijo",
  "svc_trading_price": "Od €149/sejo",
  "svc_domains_label": "Upravljanje domen",
  "svc_domains_desc": "Registracija domen, upravljanje DNS in prenosi",
  "svc_domains_price": "Od €19/leto",
  "testimonials_title": "Kaj pravijo naše stranke",
  "testimonials_subtitle": "Podjetja po vsej Evropi nam zaupajo",
  "stat_projects": "Izvedenih projektov",
  "stat_satisfaction": "Zadovoljstvo strank",
  "stat_languages": "Podprtih jezikov",
  "all_rights_reserved": "Vse pravice pridržane.",
  "form_your_name": "Vaše ime",
  "form_your_email": "Vaš email",
  "form_describe_need": "Opišite, kaj potrebujete...",
  "form_additional_feedback": "Dodatne povratne informacije? (neobvezno)",
  "form_email_followup": "Vaš email (neobvezno, za sledenje)",
  "form_budget_range": "Proračunski okvir",
  "form_timeline": "Časovni okvir",
  "form_cancel": "Prekliči",
  "form_select_services": "Izberite storitve (več možnih):",
  "rating_title": "Ocenite svojo izkušnjo z RisTA",
  "rating_helpful": "Kako koristna je bila ta pogovor?",
  "rating_overall": "Splošna izkušnja s pomočnikom",
  "rating_recommend": "Bi priporočili RisTA?",
  "rating_yes": "Da",
  "rating_no": "Ne",
  "rating_submit": "Oddaj oceno",
  "rating_skip": "Preskoči",
  "rating_thanks": "Hvala za vaše povratne informacije!",
  "generating_estimate": "Generiranje ocene stroškov...",
  "profile_info": "Podatki o profilu",
  "profile_name": "Ime",
  "profile_email": "Email",
  "profile_role": "Vloga",
  "profile_member_since": "Član od",
  "profile_rerun_onboarding": "Ponovi uvodni vodič",
  "profile_language_pref": "Želeni jezik",
  "profile_language_saved": "Jezikovna nastavitev shranjena!",
  "privacy_heading": "Pravilnik o zasebnosti",
  "terms_heading": "Pogoji uporabe",
  "about_heading": "O Infinity Business",
  "walkthrough_heading": "Vodiči",
  "services_cta_title": "Pripravljeni začeti?",
  "services_talk_rista": "Pogovorite se z RisTA",
  "nav_tools": "Orodja",
  "nav_marketplace": "Tržnica",
  "chat_digital_partner": "Digitalni partner",
  "chat_online": "Na spletu",
  "chat_help_text": "Lahko pomagam z razvojem spletnih strani, mobilnih aplikacij, dizajnom, kriptom in več.",
  "chat_your_partner": "Vaš digitalni partner",
  "chat_assistant_subtitle": "Klepetajte z vašim pametnim asistentom",
  "tab_password": "Geslo",
  "tab_rista_services": "RisTA storitve",
  "tab_analytics": "Analitika",
  "tab_projects": "Projekti",
  "tab_referral": "Priporočilni program",
  "marketplace_title": "Tržnica predlog",
  "marketplace_subtitle": "Premium predloge, ki jih lahko prilagodite. Profesionalna kakovost.",
  "marketplace_search": "Išči predloge...",
  "marketplace_purchase": "Kupi",
  "marketplace_preview": "Predogled",
  "marketplace_all": "Vse",
  "marketplace_category_website": "Spletna stran",
  "marketplace_category_brand": "Blagovna znamka",
  "marketplace_category_resume": "Življenjepis",
  "marketplace_downloads": "prenosov",
  "marketplace_features": "Funkcije",
  "case_studies_title": "Zgodbe o uspehu strank",
  "case_studies_subtitle": "Resnični rezultati resničnih podjetij. Oglejte si preobrazbo.",
  "case_studies_before": "Pred",
  "case_studies_after": "Po",
  "case_studies_cta_title": "Pripravljeni na rast vašega podjetja?",
  "case_studies_cta_desc": "Pridružite se tem podjetjem in dosezite podobne rezultate z našimi pametnimi storitvami.",
  "case_studies_cta_btn": "Začnite",
  "profile_go_homepage": "Na domačo stran",
  "onboarding_welcome_title": "Dobrodošli v Infinity Business",
  "onboarding_welcome_subtitle": "Vaš pametni digitalni partner",
  "onboarding_welcome_content": "Infinity Business ponuja celovite B2B in P2P digitalne storitve. Naš pametni asistent RisTA vas bo vodil.",
  "onboarding_welcome_item1": "Intelligent System ocena projektov",
  "onboarding_welcome_item2": "Spletne, mobilne in dizajnerske storitve",
  "onboarding_welcome_item3": "Kripto izobraževanje in naložbena orodja",
  "onboarding_welcome_item4": "Personalizirano svetovanje",
  "onboarding_next": "Naprej",
  "onboarding_get_started": "Začni",
  "onboarding_back": "Nazaj",
  "onboarding_biz_title": "Izbira storitev",
  "onboarding_biz_subtitle": "Kaj najbolje opisuje vaše potrebe?",
  "onboarding_biz_content": "Pomagajte nam priporočiti prave storitve:",
  "onboarding_biz_type_startup": "Startup / Novo podjetje",
  "onboarding_biz_type_smb": "Majhno-srednje podjetje",
  "onboarding_biz_type_enterprise": "Veliko podjetje / Korporacija",
  "onboarding_biz_type_freelancer": "Samostojni podjetnik / Posameznik",
  "onboarding_biz_type_investor": "Investitor / Kripto navdušenec",
  "change_password_title": "Spremeni geslo",
  "referral_title": "Priporočilni program",
  "referral_generate": "Ustvari mojo priporočilno kodo",
  "referral_redeem_title": "Uporabi kodo",
  "referral_redeem_btn": "Uporabi",
  "referral_referrals": "Priporočila",
  "referral_rewards": "Nagrade",
  "referral_copy_link": "Kopiraj povezavo",
  "referral_copied": "Kopirano!",
  "project_tracker_title": "Sledenje projektom",
  "analytics_total_services": "Skupno storitev",
  "analytics_completed": "Zaključeno",
  "analytics_pending": "V čakanju",
  "analytics_total_spent": "Skupno porabljeno",
  "analytics_credit_balance": "Stanje kreditov",
  "analytics_recent": "Nedavne storitve",
  "nav_try_free": "Preizkusite brezplačno",
  "testimonial_1_text": "RisTA nam je pomagala zgraditi celotno spletno prisotnost v samo 2 tednih.",
  "testimonial_2_text": "Paket blagovne znamke in koledar za družbena omrežja sta nam prihranila mesece dela.",
  "testimonial_3_text": "Redno uporabljam ustvarjalnik životopisov in orodja za analizo. Kakovost je odlična.",
  "services_cta_desc": "Pogovorite se z RisTA, nasim inteligentnim digitalnim pomocnikom, za prilagojeno ponudbo.",
  "services_free_audit": "Brezplacen SEO pregled",
  "tools_title": "Brezplacna trzna orodja",
  "tools_subtitle": "Preizkusite nasa brezplacna orodja - brez registracije",
  "sp_basic_web_name": "Osnovna izdelava spletne strani",
  "sp_basic_web_desc": "Profesionalna spletna stran za vase podjetje z modernim oblikovanjem in polno mobilno združljivostjo.",
  "sp_basic_web_feat": "Moderno odzivno oblikovanje|Do 5 strani|Integracija kontaktnega obrazca|Optimizirano za mobilne|Osnovna SEO nastavitev|Pomoc pri vnosu vsebine",
  "sp_web_store_name": "Spletna trgovina / E-Commerce",
  "sp_web_store_desc": "Popolna e-commerce platforma z integriranimi placili in trznimi orodji.",
  "sp_web_store_feat": "Popolna spletna trgovina|Obdelava placil|Upravljanje izdelkov|Sledenje narocil|SEO optimizacija|Trzna strategija vkljucena",
  "sp_custom_web_name": "Prilagojena spletna aplikacija",
  "sp_custom_web_desc": "Spletne aplikacije, narejene po vasih tocnih poslovnih zahtevah.",
  "sp_custom_web_feat": "Prilagojeno oblikovanje programske opreme|API integracije|Arhitektura baze podatkov|Razsirljiva infrastruktura|Admin nadzorne plosce|Stalna podpora",
  "sp_mobile_app_name": "Mobilna aplikacija",
  "sp_mobile_app_desc": "Nativne in cross-platform mobilne aplikacije za iOS in Android.",
  "sp_mobile_app_feat": "iOS in Android|Cross-platform razvoj|Push obvestila|Objava v trgovinah|UI/UX oblikovanje|Backend integracija",
  "sp_seo_name": "SEO in digitalni marketing",
  "sp_seo_desc": "Povecajte svojo spletno vidnost s celovitimi strategijami SEO in digitalnega marketinga.",
  "sp_seo_feat": "Popolna SEO revizija|Optimizacija kljucnih besed|Strategija vsebine|Upravljanje Google Ads|Marketing na druzabnih omrezjih|Mesecna porocila",
  "sp_graphic_name": "Graficno oblikovanje in blagovna znamka",
  "sp_graphic_desc": "Celovite resitve za blagovno znamko in graficno oblikovanje za identiteto vasega podjetja.",
  "sp_graphic_feat": "Oblikovanje logotipa|Identiteta blagovne znamke|Trzni materiali|Grafike za druzabna omrezja|Tiskovni dizajn|Vodic po slogu",
  "sp_crypto_edu_name": "Program kripto izobrazevanja",
  "sp_crypto_edu_desc": "Naucite se trgovanja s kriptovalutami in blockchain tehnologije od strokovnjakov.",
  "sp_crypto_edu_feat": "Osnove blockchaina|Strategije trgovanja|Varnost denarnic|Uvod v DeFi|Analiza trga|Osebno mentorstvo",
  "sp_invest_name": "Pametna nalozbenicka orodja",
  "sp_invest_desc": "Profesionalna orodja za sledenje in analizo nalozb, ki jih poganja UI.",
  "sp_invest_feat": "Sledilnik portfelja|Nadzorna plosca trga|UI vpogledi|Ocena tveganja|Opozorila v realnem casu|Podpora za vec borz",
  "sp_ad_name": "Oglasevalske storitve",
  "sp_ad_desc": "Dosezite milijone prek nase obsezne mreze portalov v vec regijah.",
  "sp_ad_feat": "20+ mreza portalov|10M+ doseg|Ciljane kampanje|Sledenje ucinkovitosti|Oglasi na vec platformah|Optimizacija ROI",
  "contact_heading": "Stopite v stik",
  "contact_subtitle_text": "Imate vprasanje ali zelite razpravljati o projektu? Z veseljem vas bomo slisali.",
  "contact_name_label": "Ime",
  "contact_email_label": "Email",
  "contact_subject_label": "Zadeva",
  "contact_message_label": "Sporocilo",
  "contact_name_ph": "Vase ime",
  "contact_email_ph": "vi@primer.com",
  "contact_subject_ph": "Za kaj gre?",
  "contact_message_ph": "Povejte nam o vasem projektu ali vprasanju...",
  "contact_send_btn": "Poslji sporocilo",
  "contact_sending": "Posiljanje...",
  "contact_sent_title": "Sporocilo poslano!",
  "contact_sent_msg": "Hvala za sporocilo. Odgovorili vam bomo v 24 urah.",
  "contact_send_another": "Poslji drugo sporocilo",
  "contact_info_email": "Email",
  "contact_info_location": "Lokacija",
  "contact_info_eu": "Evropska unija",
  "contact_info_response": "Cas odziva",
  "contact_info_response_time": "V 24 urah",
  "contact_info_hours": "Pon - Pet, 9:00 - 18:00 CET",
  "tf_seo_name": "Brezplacna SEO revizija",
  "tf_seo_desc": "Pridobite celovito SEO analizo katerekoli spletne strani - brez registracije.",
  "tf_color_name": "Generator barvne palete",
  "tf_color_desc": "Ustvarite lepe, harmonicne barvne palete za vaso blagovno znamko.",
  "tf_headline_name": "Analizator naslovov",
  "tf_headline_desc": "Ocenite naslove za potencial klikov in custveni vpliv.",
  "tf_chat_name": "Klepetajte z RisTA",
  "tf_chat_desc": "Pridobite takojsnje ocene projektov in raziščite storitve v 11 jezikih.",
  "tf_free_label": "Brezplacno",
  "tools_seo_title": "Hitra SEO preveritev",
  "tools_seo_desc": "Takojsnja SEO ocena za katerokoli spletno stran",
  "tools_seo_ph": "Vnesite URL spletne strani (npr. primer.com)",
  "tools_analyze": "Analiziraj",
  "tools_color_title": "Generator barvne palete",
  "tools_color_desc": "Ustvarite komplementarne barvne palete",
  "tools_headline_title": "Analizator naslovov",
  "tools_headline_desc": "Analizirajte ucinkovitost naslovov",
  "tools_headline_ph": "Vnesite svoj naslov...",
  "tools_headline_btn": "Analiziraj naslov",
  "tools_issues": "Najdene tezave",
  "tools_suggestions": "Predlogi",
  "tools_score": "Rezultat",
  "docs_heading": "Funkcije platforme",
  "docs_subtitle": "Vse, kar Infinity Business ponuja za vaso digitalno pot.",
  "docs_no_data": "Dokumentacija ni na voljo.",
  "tester_heading": "Postanite tester",
  "tester_subtitle": "Pomagajte nam izboljsati platformo in pridobite brezplacen dostop do storitev.",
  "tester_req_title": "Kaj je potrebno",
  "tester_benefit_title": "Kaj dobite",
  "tester_apply_title": "Prijavite se",
  "tester_submit_app": "Poslji prijavo",
  "tester_applied_title": "Prijava oddana",
  "tester_applied_msg": "Nas admin bo pregledal vaso prijavo in boste obvesceni.",
  "tester_need_account": "Za prijavo potrebujete racun.",
  "tester_dash_title": "Nadzorna plosca testerja",
  "tester_weekly_logins": "Tedenske prijave",
  "tester_weekly_reports": "Tedenska porocila",
  "tester_target_met": "Cilj dosezen!",
  "tester_total_reports": "Skupno oddanih porocil",
  "tester_on_track": "Na pravi poti",
  "tester_at_risk": "Pod tveganjem",
  "tester_report_heading": "Oddajte porocilo o napaki / povratne informacije",
  "tester_submit_report": "Oddaj porocilo",
  "seo_page_title": "Brezplacna SEO revizija",
  "seo_page_btn": "Zazeni revizijo",
  "seo_page_running": "Analiziranje...",
  "referral_reward_title": "Kako nagrade delujejo",
  "referral_reward_desc": "Zasluzite 10% od vsakega nakupa uporabnikov, ki jih priporocite, samodejno pripisano kot brezplacne kredite.",
  "referral_reward_1": "Delite svojo edinstveno povezavo za priporocila s prijatelji",
  "referral_reward_2": "Ko opravijo nakup, zasluzite 10% kot brezplacne kredite",
  "referral_reward_3": "Krediti se samodejno dodajo vasemu stanju",
  "referral_earned_label": "Zasluzeni krediti",
  "profile_picture": "Profilna slika",
  "profile_bio": "Biografija",
  "profile_website": "Spletna stran",
  "profile_interests": "Interesi",
  "profile_upload_photo": "Nalozi fotografijo",
  "profile_save": "Shrani profil",
  "admin_notes": "Admin zapiski",
  "admin_notes_add": "Dodaj zapisek",
  "sp_logo_name": "Oblikovanje logotipa",
  "sp_logo_desc": "Profesionalno oblikovanje logotipa, ki zajame bistvo vaše blagovne znamke.",
  "sp_logo_feat": "3 edinstveni koncepti|Neomejene revizije|Vektorske datoteke|Barvno + Č/B|Smernice znamke|Social media komplet",
  "sp_brand_name": "Celostna identiteta znamke",
  "sp_brand_desc": "Celoten paket identitete znamke z logom, barvno paleto in smernicami.",
  "sp_brand_feat": "Logo|Barvna paleta|Tipografija|Vizitka|Dopisni papir|PDF smernice|Social predloge",
  "sp_poster_name": "Oblikovanje plakata",
  "sp_poster_desc": "Privlačni plakati za dogodke in oglaševalske kampanje.",
  "sp_poster_feat": "Prilagojena ilustracija|Datoteke za tisk|Več velikosti|2 kroga revizij|Visoka ločljivost|Digitalno + tisk",
  "sp_flyer_name": "Oblikovanje letaka",
  "sp_flyer_desc": "Profesionalno oblikovanje letakov za trženje in dogodke.",
  "sp_flyer_feat": "Sprednja in zadnja stran|PDF za tisk|Digitalna verzija|QR koda|2 reviziji|Več formatov",
  "sp_menu_name": "Oblikovanje jedilnika",
  "sp_menu_desc": "Čudoviti jedilniki za restavracije in kavarne.",
  "sp_menu_feat": "Prilagojena postavitev|Fotografije|QR verzija|Datoteke za tisk|Sezonska posodobitev|Več strani",
  "currency_label": "Valuta",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Smo tehnološko podjetje, usmerjeno v pametne digitalne rešitve. Infinity Business, ustanovljen leta 2026, združuje inovacije umetne inteligence z dokazanim strokovnim znanjem.",
  "about_values": "Naše Vrednote",
  "about_what_we_do": "Kaj Počnemo",
  "about_meet_rista": "Spoznajte RisTA-o",
  "about_rista_desc": "RisTA je naš inteligentni pomočnik. Pomaga pri kvalifikaciji zahtev, nudi takojšnje nasvete in vas poveže z našo ekipo. Na voljo 24/7, večjezično.",
  "about_talk_rista": "Pogovorite se z RisTA-o",
  "about_val_trust": "Zaupanje in Varnost",
  "about_val_trust_desc": "Uporabljamo najvišje standarde zaščite podatkov.",
  "about_val_innovation": "Inovacija",
  "about_val_innovation_desc": "Najsodobnejša pametna tehnologija poganja naše rešitve.",
  "about_val_partnership": "Partnerstvo",
  "about_val_partnership_desc": "Delamo ob vas kot pravi partner.",
  "about_val_global": "Globalni Doseg",
  "about_val_global_desc": "Naše rešitve so zasnovane za mednarodne trge.",
  "about_svc_web": "Spletni Razvoj",
  "about_svc_web_desc": "Full-stack spletne aplikacije, e-commerce platforme in CMS rešitve.",
  "about_svc_mobile": "Mobilne Aplikacije",
  "about_svc_mobile_desc": "Nativne in cross-platform aplikacije za iOS in Android.",
  "about_svc_software": "Prilagojena Programska Oprema",
  "about_svc_software_desc": "Programske rešitve po meri za avtomatizacijo poslovnih procesov.",
  "about_svc_invest": "Pametne Naložbe",
  "about_svc_invest_desc": "Pametna kripto in DeFi orodja s profesionalnimi trgovalnimi storitvami.",
  "micro_tools_title": "Pametna Mikro-orodja",
  "micro_tools_subtitle": "Takojšnji pametni vpogledi za generiranje strank in strateško načrtovanje.",
  "micro_tools_all": "Vse",
  "micro_tools_try": "Preizkusi",
  "micro_tools_generate_free": "Generiraj (Brezplačno)",
  "micro_tools_generate_paid": "Generiraj",
  "micro_tools_close": "Zapri",
  "micro_tools_interested": "Vas zanima?",
  "tools_view_service": "Ogled storitve",
  "tools_talk_rista": "Pogovor z RisTA",
  "competitor_title": "Pametna Analiza konkurence",
  "competitor_desc": "Vnesite URL konkurenta za pametno analizo s primerjavo SEO in pregledom dizajna.",
  "competitor_url_ph": "Vnesite URL konkurenta",
  "competitor_analyze": "Analiziraj konkurenta",
  "competitor_score": "Skupna ocena",
  "competitor_seo": "SEO Analiza",
  "competitor_design": "Analiza dizajna",
  "competitor_content": "Analiza vsebine",
  "competitor_strengths": "Prednosti",
  "competitor_weaknesses": "Slabosti",
  "competitor_opportunities": "Priložnosti",
  "competitor_recommendations": "Priporočila",
  "accessibility_title": "Preverjanje dostopnosti",
  "accessibility_desc": "Preverjanje standardov dostopnosti",
  "cat_lead_gen": "Generiranje leadov",
  "cat_discovery": "Odkrivanje poročil",
  "cat_email": "E-pošta in Workflow",
  "cat_planning": "Načrtovanje in strategija",
  "cat_content": "Vsebina in pozicioniranje",
  "sp_tools_title": "Pametne mikro-storitve",
  "sp_tools_desc": "Takojšnje pametne storitve za vsebino, blagovno znamko, analizo in dokumente.",
  "sp_free_title": "Brezplačna orodja",
  "sp_free_desc": "Preizkusite našo platformo s temi brezplačnimi orodji.",
  "a11y_checker": "Preverjanje dostopnosti",
  "a11y_rescan": "Ponovno preveri",
  "a11y_scanning": "Izvajanje WCAG revizije...",
  "a11y_compliant": "Skladno",
  "a11y_passed": "uspešno",
  "a11y_violations": "kršitve",
  "a11y_incomplete": "potreben pregled",
  "a11y_issues_found": "Najdene težave",
  "a11y_no_issues": "Ni najdenih težav z dostopnostjo!",
  "a11y_disclaimer": "Samodejne preverbe pokrijejo ~30% težav. Priporočeno je ročno testiranje z bralniki zaslona.",
  "a11y_error": "Revizija ni uspela. Poskusite znova.",
  "admin_ratings": "Ocene in povratne informacije",
  "admin_timeline": "Časovnica projekta",
  "admin_add_milestone": "Dodaj mejnik",
  "admin_milestone_title": "Naslov mejnika",
  "admin_milestone_desc": "Opis (neobvezno)",
  "admin_no_milestones": "Še ni mejnikov. Dodajte prvega!",
  "admin_email_templates_desc": "Prilagodite e-poštne predloge z vizualnim urejevalnikom blokov.",
  "admin_preloader": "Nastavitve prednalaganja",
  "admin_image_gen": "Generiranje slik",
  "admin_health_score": "Ocena zdravja",
  "nav_health_score": "Ocena zdravja",
  "admin_new": "novo",
  "admin_score": "Ocena",
  "admin_avg_rating": "Povp. ocena",
  "admin_avg_exp": "Povp. izkušnja",
  "admin_reviews": "ocen",
  "admin_out_of": "Od",
  "admin_total": "Skupaj",
  "admin_unread": "Neprebrano",
  "admin_active": "Aktivno",
  "admin_pending": "V čakanju",
  "admin_save": "Shrani",
  "admin_cancel": "Prekliči",
  "admin_delete": "Izbriši",
  "admin_edit": "Uredi",
  "admin_status": "Status",
  "admin_actions": "Dejanja",
  "admin_created": "Ustvarjeno",
  "admin_updated": "Posodobljeno",
  "admin_view_all": "Prikaži vse",
  "admin_no_data": "Ni podatkov",
  "status_planned": "Načrtovano",
  "status_in_progress": "V izvajanju",
  "status_completed": "Zaključeno",
  "status_blocked": "Blokirano",
  "priority_low": "Nizka",
  "priority_medium": "Srednja",
  "priority_high": "Visoka",
  "priority_critical": "Kritična",
  "analytics_subscription": "Naročnina",
  "developer_title": "API za razvijalce",
  "developer_subtitle": "Vključite naše inteligentne storitve v svoje aplikacije",
  "estimate_accept": "Sprejmi in pošlji",
  "estimate_revise": "Popravi",
  "estimate_title": "Ocena stroškov projekta",
  "estimate_service": "Storitev",
  "estimate_complexity": "Kompleksnost",
  "estimate_base_price": "Osnovna cena",
  "estimate_cost": "Ocenjeni stroški",
  "estimate_features": "Ključne lastnosti",
  "hosting_title": "Paketi gostovanja",
  "hosting_subtitle": "Zanesljivo, hitro gostovanje za vaše podjetje",
  "sp_health_score": "Ocena zdravja spletne strani",
  "sp_health_score_desc": "Celovita analiza spletne strani: SEO, zmogljivost, varnost in dostopnost.",
  "sp_health_score_name": "Ocena zdravja spletne strani",
  "sp_health_score_feat": "SEO analiza|Preverjanje zmogljivosti|Varnostno skeniranje|Revizija dostopnosti|Podrobno poročilo|Nasveti za izboljšave",
  "sp_hosting_name": "Upravljano spletno gostovanje",
  "sp_hosting_desc": "Varna, hitra in zanesljiva infrastruktura gostovanja za vaše spletne strani in aplikacije.",
  "sp_hosting_feat": "99,9% razpoložljivost|SSL certifikati|Dnevne varnostne kopije|CDN integracija|24/7 nadzor|Samodejno prilagajanje",
  "sp_biz_plan_name": "Pametni poslovni načrt",
  "sp_biz_plan_desc": "Ustvarite celovit poslovni načrt s financami, analizo trga in strategijo rasti.",
  "sp_biz_plan_feat": "Izvršni povzetek|Analiza trga|Finančne projekcije|Pregled konkurence|Strategija rasti|Format za investitorje",
  "sp_seo_report_name": "Poročilo o reviziji spletne strani",
  "sp_seo_report_desc": "Avtomatizirana analiza strani s praktičnimi SEO priporočili in vpogledi v zmogljivost.",
  "sp_seo_report_feat": "100+ kontrolnih točk|Metrike zmogljivosti|SEO priporočila|Mobilna analiza|Varnostni pregled|Akcijski načrt",
  "sp_email_campaign_name": "Nastavitev e-poštnega marketinga",
  "sp_email_campaign_desc": "Profesionalna nastavitev e-poštne kampanje z besedili, zaporedji in ciljanjem občinstva.",
  "sp_email_campaign_feat": "Pisanje e-pošte|Nastavitev zaporedij|Ciljanje občinstva|A/B testiranje|Nastavitev analitike|Oblikovanje predlog",
  "sp_competitor_name": "Analiza konkurence",
  "sp_competitor_desc": "Poglobljeno konkurenčno obveščanje s SEO primerjavo, pregledom oblikovanja in analizo vrzeli.",
  "sp_competitor_feat": "SEO primerjava|Pregled oblikovanja|Vrzeli v vsebini|Tržno pozicioniranje|SWOT analiza|Strateška priporočila",
  "sp_legal_docs_name": "Generator pravnih dokumentov",
  "sp_legal_docs_desc": "Profesionalne pravne predloge: NDA, pogodbe in Splošni pogoji.",
  "sp_legal_docs_feat": "NDA predloge|Pogodbe o storitvah|Splošni pogoji|Politike zasebnosti|Skladnost z GDPR|Prilagojene klavzule",
  "sp_resume_name": "Pametni ustvarjalec življenjepisov",
  "sp_resume_desc": "Ustvarite ATS-optimizirane življenjepise, prilagojene vašemu ciljnemu delovnemu mestu.",
  "sp_resume_feat": "ATS optimizacija|Industrijske predloge|Ujemanje ključnih besed|Spremno pismo|LinkedIn optimizacija|PDF izvoz",
  "sp_brand_kit_name": "Pametni logotip in paket blagovne znamke",
  "sp_brand_kit_desc": "Celoten paket identitete blagovne znamke s koncepti logotipa, barvno paleto in materiali za družbene medije.",
  "sp_brand_kit_feat": "Koncepti logotipa|Barvna paleta|Tipografija|Materiali za družbene medije|Smernice blagovne znamke|Komplet ikon",
  "sp_social_cal_name": "Koledar družbenih medijev",
  "sp_social_cal_desc": "30 dni inteligentno ustvarjenih objav na družbenih medijih s strategijo angažiranosti.",
  "sp_social_cal_feat": "30-dnevni koledar|Besedila objav|Strategija oznak|Nasveti za angažiranost|Najboljši čas objave|Optimizacija platform",
  "sp_translation_name": "Pametno prevajanje",
  "sp_translation_desc": "Profesionalno prevajanje dokumentov v 50+ jezikov s kulturno prilagoditvijo.",
  "sp_translation_feat": "50+ jezikov|Kulturna prilagoditev|Tehnični izrazi|Hitra dostava|Lektura|Ohranjanje formata",
  "sp_video_script_name": "Pametni pisec video skript",
  "sp_video_script_desc": "Privlačne video skripte za YouTube, TikTok in oglase, optimizirane za maksimalno angažiranost.",
  "sp_video_script_feat": "YouTube skripte|TikTok vsebine|Oglasna besedila|Optimizacija uvoda|Postavitev CTA|Nasveti za angažiranost",
  "sp_free_seo_name": "Brezplačna SEO revizija",
  "sp_free_seo_desc": "Izvedite brezplačno celovito SEO revizijo katere koli spletne strani.",
  "sp_free_seo_feat": "Takojšnji rezultati|100+ preverb|Ocena zmogljivosti|Mobilna preverba|Varnostno skeniranje|Brezplačno poročilo",
  "sp_free_tools_name": "Brezplačna digitalna orodja",
  "sp_free_tools_desc": "Dostopajte do naše zbirke brezplačnih orodij: barvne palete, analizator naslovov in več.",
  "sp_free_tools_feat": "Generator barvnih palet|Analizator naslovov|Generator gesel|QR koda generator|Pretvornik enot|Brez registracije",
  "admin_chat_analytics": "Analitika klepetov",
  "admin_ab_testing": "A/B testiranje",
  "admin_ui_toggles": "UI stikala",
  "admin_audit_trail": "Revizijska sled",
  "admin_adv_reports": "Napredna poročila",
  "admin_rate_limiting": "Omejitev hitrosti",
  "admin_email_builder": "Graditelj e-pošte",
  "admin_rbac": "Nadzor dostopa",
  "admin_social_auto": "Avtomatizacija družbenih medijev",
  "admin_health_monitor": "Nadzor zdravja",
  "profile_country": "Država",
  "profile_country_ph": "npr. Slovenija, Nemčija, Avstrija",
  "health_title": "Ocena zdravja spletne strani",
  "health_desc": "Celovita analiza SEO, zmogljivosti, varnosti in dostopnosti vaše spletne strani na eni nadzorni plošči.",
  "health_premium_badge": "Premium funkcija",
  "health_url_ph": "Vnesite URL spletne strani (npr. primer.si)",
  "health_scan_btn": "Skeniraj",
  "health_scanning": "Skeniranje...",
  "health_scan_error": "Skeniranje spletne strani ni uspelo. Preverite URL.",
  "health_overall": "Skupna ocena zdravja",
  "health_response": "Odziv",
  "health_size": "Velikost",
  "health_seo": "SEO",
  "health_perf": "Zmogljivost",
  "health_security": "Varnost",
  "health_a11y": "Dostopnost",
  "health_history": "Zgodovina skeniranj",
  "health_login_required": "Prijavite se za uporabo ocene zdravja",
  "health_login_desc": "Ustvarite brezplačen račun za skeniranje spletne strani in sledenje izboljšavam.",
  "health_upsell_title": "Želite redno spremljanje?",
  "health_upsell_desc": "Nadgradite na Premium za samodejne tedenske preglede, e-poštna opozorila in sledenje trendom.",
  "health_upgrade_btn": "Nadgradi na Premium",
  "seo_cta_title": "Potrebujete pomoč pri odpravljanju teh težav?",
  "seo_cta_desc": "Naša inteligentna SEO revizija pokriva 100+ kontrolnih točk. Pridobite strokovno pomoč.",
  "walkthrough_gmail": "Pametni Gmail pomočnik",
  "walkthrough_gmail_desc": "Poglejte, kako RisTA organizira vaš nabiralnik",
  "walkthrough_calendar": "Osebni svetovalec",
  "walkthrough_calendar_desc": "Koledar, opravila in e-pošta prek klepeta",
  "walkthrough_ai": "Storitve inteligentnega sistema",
  "walkthrough_ai_desc": "Življenjepis, poslovni načrti, paketi blagovne znamke in več",
  "submit_service_request": "Oddajte svojo zahtevo za storitev",
  "profile_admin_dashboard": "Odpri nadzorno ploščo",
  "profile_appearance": "Videz in dostopnost",
  "profile_theme": "Tema",
  "profile_text_size": "Velikost besedila",
  "profile_text_size_hint": "Prilagodite velikost besedila za lažje branje.",
  "try_free_title": "Brezplačna orodja in poskusne storitve",
  "try_free_subtitle": "Brez kreditne kartice. Začnite takoj uporabljati naša orodja.",
  "try_free_section": "Popolnoma brezplačno — brez računa",
  "try_free_trial_section": "Storitve inteligentnega sistema — Preizkusite s krediti",
  "try_free_trial_desc": "Registrirajte se za pridobitev kreditov in dostop do pametnih storitev.",
  "try_free_cta": "Pripravljeni za začetek?",
  "try_free_cta_desc": "Ustvarite brezplačen račun za pridobitev prvih kreditov in odklepanje vseh pametnih storitev.",
  "try_free_cta_btn": "Brezplačna registracija",
  "review_title": "Kaj pravijo naše stranke",
  "review_subtitle": "Resnične povratne informacije podjetij, ki smo jim pomagali",
  "testimonial_1_role": "Direktor, TechStart d.o.o.",
  "testimonial_2_role": "Direktorica marketinga, BioFresh",
  "testimonial_3_role": "Samostojni razvijalec",
  "admin_overview": "Pregled",
  "admin_my_account": "Moj račun",
  "admin_health": "Monitor zdravja",
  "admin_analytics": "Analitika",
  "admin_integrations": "Integracije",
  "admin_requests": "Zahteve za storitve",
  "admin_high_value": "Visoko vredne stranke",
  "admin_followups": "Nadaljnja e-pošta",
  "admin_users": "Upravljanje uporabnikov",
  "admin_crypto_payments": "Kripto plačila",
  "admin_bug_reports": "Poročila o napakah",
  "admin_pricing": "Dinamično oblikovanje cen",
  "admin_defi": "DeFi elementi",
  "admin_chat_sessions": "Seje klepeta",
  "admin_language_requests": "Jezikovne zahteve",
  "admin_notifications": "Obvestila",
  "admin_sendgrid": "E-pošta (SendGrid)",
  "admin_ai_config": "Konfiguracija modela",
  "admin_live_analytics": "Analitika v živo",
  "admin_system_config": "Sistemska konfiguracija",
  "admin_backup": "Varnostno kopiranje in obnovitev",
  "admin_referrals": "Program priporočil",
  "admin_invoices": "Fakturiranje",
  "admin_billing": "Ponavljajoče se zaračunavanje",
  "admin_blog": "Upravljanje bloga",
  "admin_logo": "Logotip in ikona",
  "admin_promo": "Promocijske kode",
  "admin_currency": "Več valut",
  "admin_domain": "Upravljanje domen",
  "admin_cdn": "Upravljanje CDN",
  "admin_social": "Družbeni mediji",
  "admin_avatar_selector": "Izbira avatarja",
  "admin_avatar_builder": "Graditelj avatarja",
  "admin_client_portal": "Portal za stranke",
  "admin_abandoned_carts": "Zapuščene košarice",
  "rista_login_required": "Zahtevana prijava",
  "rista_login_desc": "Prijavite se ali ustvarite račun za pogovor z RisTA in pridobite prilagojena poslovna priporočila.",
  "rista_login_btn": "Prijava",
  "rista_signup_btn": "Registracija",
  "admin_high_leads": "Prednostne stranke",
  "admin_surveys": "Ankete o zadovoljstvu",
  "admin_rista": "Storitve RisTA",
  "admin_docs": "Dokumentacija",
  "admin_audit": "Revizija platforme",
  "admin_kb": "Baza znanja",
  "admin_reports": "Poročila administratorja",
  "admin_ad_gen": "Generator oglasov",
  "admin_service_mgr": "Upravitelj storitev",
  "admin_tester": "Program testerjev",
  "admin_credits": "Konfiguracija kreditov",
  "admin_account_mgmt": "Upravljanje računa",
  "admin_payment_opts": "Možnosti plačila",
  "admin_lead_tracking": "Sledenje strankam",
  "admin_demo": "Demo dostop",
  "admin_crypto_trading": "Kripto trgovanje",
  "admin_auto_posting": "Pametno samodejno objavljanje",
  "admin_fb": "FB analitika",
  "admin_referral_board": "Lestvica priporočil",
  "admin_escalations": "Eskalacije klepetov",
  "admin_portfolio": "Upravitelj portfelja",
  "admin_email_templates": "E-poštne predloge",
  "admin_social_icons": "Ikone družbenih medijev",
  "admin_ai_prompts": "Pametni pozivi",
  "admin_panel": "Nadzorna plošča",
  "admin_sign_out": "Odjava",
  "admin_search_tabs": "Iskanje zavihkov...",
  "admin_demo_banner": "SAMO ZA BRANJE — Demo račun (Vsi uporabniški podatki so skriti)",
  "admin_system_admin": "SISTEMSKI ADMINISTRATOR",
  "admin_loading": "Nalaganje...",
  "admin_no_matching": "Ni ujemajočih zavihkov",
  "tester_req_1": "Prijavite se vsaj 5-krat na teden",
  "tester_req_2": "Oddajte vsaj 10 poročil o napakah/povratnih informacij na teden",
  "tester_req_3": "Testirajte različne funkcije, strani in uporabniške tokove",
  "tester_benefit_1": "Brezplačen dostop do inteligentnih storitev (na zahtevo)",
  "tester_benefit_2": "Nadzorna plošča testerja s sledenjem napredka",
  "tester_benefit_3": "Prednostna podpora ekipe",
  "tester_motivation": "Zakaj želite postati tester?",
  "tester_motivation_ph": "Povejte nam, zakaj bi radi pomagali testirati platformo...",
  "tester_experience": "Testne izkušnje (neobvezno)",
  "tester_experience_ph": "Katere koli ustrezne izkušnje...",
  "tester_dash_desc": "Ohranite status testerja z izpolnjevanjem tedenskih ciljev.",
  "tester_logins_needed": "še prijav potrebnih ta teden",
  "tester_reports_needed": "še poročil potrebnih ta teden",
  "tester_report_title_ph": "Naslov (npr. 'Gumb ni klikljiv na mobilnem')",
  "tester_report_desc_ph": "Podrobno opišite težavo ali predlog...",
  "tester_report_page_ph": "URL strani (neobvezno)",
  "seo_page_desc": "Vnesite URL katere koli spletne strani za celovito SEO analizo s praktičnimi priporočili.",
  "seo_page_ph": "Vnesite URL spletne strani (npr. primer.si)",
  "seo_page_error": "Revizija spletne strani ni uspela. Preverite URL in poskusite znova.",
  "profile_bio_ph": "Povejte nam o sebi...",
  "profile_website_ph": "https://vasastran.si",
  "profile_interests_ph": "npr. Spletni razvoj, Kripto, Tehnologija",
  "admin_notes_ph": "Dodajte opombo o tem uporabniku...",
  "sub_most_popular": "Najbolj priljubljeno",
  "sub_free": "Brezplačno",
  "sub_one_time": "enkratno",
  "sub_team_members": "Člani ekipe",
  "sub_members_info": "Povabite člane ekipe za skupno rabo načrta. Vsak član dobi svojo prijavo in dostop.",
  "sub_show_less": "Prikaži manj",
  "sub_more_features": "več funkcij",
  "sub_pay_with": "Plačaj z",
  "sub_preferred": "prednostno",
  "sub_live_crypto": "Cene kriptovalut v živo (EUR in USD)",
  "profile_change_avatar": "Spremeni avatar",
  "profile_about": "O vas",
  "profile_interests_hint": "Ločite interese z vejicami",
  "privacy_s1_title": "1. Informacije, ki jih zbiramo",
  "privacy_s2_title": "2. Kako uporabljamo vaše podatke",
  "privacy_s3_title": "3. Deljenje podatkov",
  "privacy_s4_title": "4. Varnost podatkov",
  "privacy_s5_title": "5. Vaše pravice",
  "privacy_s6_title": "6. Piškotki in sledenje",
  "privacy_s7_title": "7. Hramba podatkov",
  "privacy_s8_title": "8. Mednarodni prenosi",
  "privacy_s9_title": "9. Spremembe te politike",
  "privacy_s10_title": "10. Kontaktirajte nas",
  "privacy_intro": "Infinity Business (\"mi\", \"nas\"), ki ga upravlja Liber Nostra d.o.o., je zavezan k varovanju vaše zasebnosti.",
  "privacy_last_updated": "Zadnja posodobitev: 7. marca 2026",
  "terms_s1_title": "1. Uvod",
  "terms_s2_title": "2. Storitve",
  "terms_s3_title": "3. Uporabniški računi",
  "terms_s4_title": "4. Plačila in zaračunavanje",
  "terms_s5_title": "5. Izjava o odgovornosti za inteligentne storitve",
  "terms_s6_title": "6. Intelektualna lastnina",
  "terms_s7_title": "7. Zasebnost in podatki",
  "terms_s8_title": "8. Izjava o odgovornosti za kriptovalute",
  "terms_s9_title": "9. Omejitev odgovornosti",
  "terms_s10_title": "10. Spremembe",
  "terms_s11_title": "11. Veljavno pravo",
  "terms_s12_title": "12. Kontakt",
  "terms_last_updated": "Zadnja posodobitev: februar 2026",
  "referral_subtitle": "Povabite prijatelje in zaslužite nagrade",
  "marketplace_close_preview": "Zapri predogled",
  "marketplace_live_preview": "Predogled v živo",
  "billing_management": "Upravljanje zaračunavanja",
  "billing_manage_desc": "Upravljajte plačilne metode, preglejte račune ali posodobite podatke o zaračunavanju.",
  "billing_manage_btn": "Upravljaj zaračunavanje",
  "billing_cancel_btn": "Prekliči načrt",
  "change_password_current": "Trenutno geslo",
  "change_password_new": "Novo geslo",
  "change_password_confirm": "Potrdi novo geslo",
  "change_password_btn": "Spremeni geslo",
  "change_password_social": "Sprememba gesla ni na voljo za račune s socialnim prijavljanjem.",
  "nav_currency": "Valuta",
  "nav_orders": "Moja naročila",
  "plan_features": "Funkcije vašega načrta",
  "project_no_projects": "Še ni projektov. Projekti se bodo pojavili, ko kupite storitev.",
  "onboarding_services_title": "Raziščite naše storitve",
  "onboarding_services_subtitle": "Dve kategoriji, prilagojeni za vas",
  "onboarding_services_content": "Ponujamo dve kategoriji storitev:",
  "onboarding_services_item1": "B2B: Spletni razvoj, mobilne aplikacije, grafično oblikovanje, gostovanje, programska oprema, oglasi, API",
  "onboarding_services_item2": "P2P: Izobraževanje o kriptovalutah, DeFi, trg domen, upravljano trgovanje, digitalna orodja",
  "onboarding_services_item3": "Pametna mikro-orodja: Tržni posnetki, analiza konkurence, generatorji e-pošte, obrisi blogov, kalkulatorji TAM in več",
  "onboarding_services_item4": "Kadar koli se pogovorite z Risto za personalizirane ponudbe in priporočila storitev",
  "onboarding_credits_title": "Kreditni sistem",
  "onboarding_credits_subtitle": "Predplačniško stanje za pametne storitve",
  "onboarding_credits_content": "Uporabite kredite za takojšen dostop do naših pametnih storitev:",
  "onboarding_credits_item1": "1 EUR = 1 kredit. Osnovni: 29 kreditov, Premium: 79, Doživljenjski: 499",
  "onboarding_credits_item2": "Brezplačna orodja so na voljo brez kreditov. Plačljiva mikro-orodja stanejo $1 vsako",
  "onboarding_credits_item3": "Količinski popusti: 5% pri 50+ EUR, 10% pri 100+, 15% pri 250+, 20% pri 500+",
  "onboarding_credits_item4": "Napolnite s kartico, PayPal, myPOS ali kriptovaluto na plošči kreditov",
  "onboarding_chat_title": "Pogovorite se z Risto",
  "onboarding_chat_subtitle": "Vaš digitalni partner je pripravljen",
  "onboarding_chat_content": "RisTA vam lahko pomaga z:",
  "onboarding_chat_item1": "Pridobivanje ocen in ponudb za projekte",
  "onboarding_chat_item2": "Podrobno raziskovanje možnosti storitev",
  "onboarding_chat_item3": "Oddajanje zahtev za storitve",
  "onboarding_chat_item4": "Odgovarjanje na vprašanja v 11 jezikih",
  "support_tickets": "Zahtevki za podporo",
  "admin_support_tickets": "Zahtevki za podporo",
  "admin_auto_translate": "Samodejno prevajanje",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "AI iskanje strank",
  "admin_project_mgmt": "Upravljanje projektov",
  "admin_analytics_widget": "Analitični pripomoček",
  "admin_doc_mgmt": "Upravljanje dokumentov",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "Bela etiketa",
  "admin_multi_tenant": "Več najemnikov",
  "popular_services": "Priljubljene storitve",
  "popular_services_desc": "Najpogosteje zahtevano s strani naših strank",
  "purchases": "Nakupi",
  "admin_funnel": "Konverzijski lijak",
  "admin_wl_licensing": "SaaS licence",
  "admin_analytics_export": "Izvoz analitike",
  "service_detail_features": "Kaj je vključeno",
  "service_detail_related": "Povezane storitve",
  "service_detail_back": "Vse storitve",
  "checkout_currency": "Valuta plačila",
  "upsell_title": "Dokončajte nastavitev",
  "upsell_desc": "Stranke, ki so kupile podobno, so dodale tudi:",
  "cart_checkout": "Plačilo",
  "cart_empty": "Vaša košarica je prazna",
  "push_notifications": "Push obvestila",
  "push_enabled": "Obvestila omogočena",
  "push_disabled": "Omogoči obvestila",
  "blog_ai_generate": "AI generiranje",
  "blog_gen_service": "Generiraj za storitev",
  "blog_generating": "Generiranje...",
  "export_revenue": "Poročilo o prihodkih",
  "export_funnel": "Konverzijski lijak",
  "export_users": "Seznam uporabnikov",
  "export_pdf": "Povzetek",
  "license_generate": "Ustvari licenco",
  "license_revoke": "Prekliči",
  "license_renew": "Obnovi",
  "license_validate": "Preveri",
  "tier_starter": "Začetni",
  "tier_professional": "Profesionalni",
  "tier_enterprise": "Podjetniški",
  "blog_subtitle": "Vpogledi, novice in vodiči od Infinity Business.",
  "blog_search_placeholder": "Iskanje člankov...",
  "blog_all": "Vse",
  "blog_no_posts": "Ni najdenih objav. Kmalu se vrnite!",
  "blog_prev": "Prejšnja",
  "blog_next": "Naslednja",
  "blog_back": "Nazaj na blog",
  "micro_tools": "Pametna mikro orodja",
  "micro_tools_title": "Pametna mikro orodja",
  "micro_tools_subtitle": "Brezplačna AI mikro orodja za vaše podjetje",
  "color_palette_title": "Generator barvnih palet",
  "color_palette_desc": "Ustvarite lepe barvne palete za svojo blagovno znamko",
  "color_palette_generate": "Ustvari paleto",
  "color_palette_copy": "Kopiraj",
  "color_palette_copied": "Kopirano!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Komplementarna",
  "color_palette_analogous": "Analogna",
  "color_palette_triadic": "Triadna",
  "color_palette_monochromatic": "Monokromatska",
  "admin_menu_overview": "Pregled",
  "admin_menu_users": "Uporabniki",
  "admin_menu_blog": "Upravitelj bloga",
  "admin_menu_analytics": "Analitika",
  "admin_menu_settings": "Nastavitve",
  "admin_menu_services": "Storitve",
  "admin_menu_chat": "Pogovorne seje",
  "admin_menu_notifications": "Obvestila",
  "admin_menu_support": "Podpora",
  "admin_menu_security": "Varnost",
  "admin_menu_backup": "Varnostna kopija",
  "admin_menu_revenue": "Prihodki",
  "admin_menu_funnel": "Lijak",
  "admin_menu_invoicing": "Izdajanje računov",
  "admin_menu_projects": "Projekti",
  "admin_menu_email": "Urejevalnik e-pošte",
  "admin_menu_ai_config": "AI konfiguracija",
  "admin_menu_live_analytics": "Analitika v živo",
  "admin_menu_platform_audit": "Revizija platforme",
  "docs_title": "Dokumentacija",
  "docs_subtitle": "Naučite se uporabljati našo platformo",
  "try_free_title": "Preizkusite brezplačno",
  "try_free_subtitle": "Brezplačno preizkusite naše storitve",
  "subscription_title": "Naročniški načrti",
  "subscription_subtitle": "Izberite načrt, ki vam ustreza",
  "portfolio_title": "Portfelj",
  "portfolio_subtitle": "Naše delo govori samo zase",
  "svc_web-dev_label": "Spletni razvoj",
  "svc_web-dev_desc": "Spletne strani, pristajalne strani in spletne aplikacije",
  "svc_mobile-app_label": "Razvoj mobilnih aplikacij",
  "svc_mobile-app_desc": "iOS & Android aplikacije",
  "svc_graphic-design_label": "Grafično oblikovanje",
  "svc_graphic-design_desc": "Logotipi, branding, marketinško gradivo",
  "svc_custom-software_label": "Programska oprema po meri",
  "svc_custom-software_desc": "Prilagojena poslovna avtomatizacija",
  "svc_ai-business-plan_label": "Pametni generator poslovnih načrtov",
  "svc_ai-business-plan_desc": "Celovit poslovni načrt s financami in analizo trga",
  "svc_ai-seo-report_label": "Revizija spletne strani in SEO poročilo",
  "svc_ai-seo-report_desc": "Avtomatizirana analiza s priporočili",
  "svc_ai-email-campaign_label": "Nastavitev email marketinga",
  "svc_ai-email-campaign_desc": "AI piše besedila in nastavi email sekvence",
  "svc_ai-competitor-analysis_label": "Poročilo analize konkurence",
  "svc_ai-competitor-analysis_desc": "Tržna inteligenca in pozicioniranje",
  "svc_ai-legal-docs_label": "Generator pravnih dokumentov",
  "svc_ai-legal-docs_desc": "NDA, pogodbe, predloge pogojev uporabe",
  "svc_crypto-education_label": "Kripto izobraževanje",
  "svc_crypto-education_desc": "Naučite se blockchain, DeFi in kripto osnove",
  "svc_investment-tools_label": "Naložbena orodja",
  "svc_investment-tools_desc": "Sledenje portfelju in analiza trga",
  "svc_defi-solutions_label": "DeFi rešitve",
  "svc_defi-solutions_desc": "Pametne pogodbe, yield farming",
  "svc_personal-advertising_label": "Osebna blagovna znamka",
  "svc_personal-advertising_desc": "Zgradite svojo spletno prisotnost",
  "svc_ai-resume_label": "Pametni graditelj življenjepisov",
  "svc_ai-resume_desc": "ATS-optimizirani življenjepisi",
  "svc_ai-brand-kit_label": "Pametni logotip in brand kit",
  "svc_ai-brand-kit_desc": "Logotip, barvna paleta, tipografija in social assets",
  "svc_ai-social-calendar_label": "Koledar družbenih omrežij in analiza",
  "svc_ai-social-calendar_desc": "30 dni AI ustvarjenih objav",
  "svc_ai-translation_label": "Pametna prevajalska storitev",
  "svc_ai-translation_desc": "Profesionalni prevod v 50+ jezikih",
  "svc_ai-video-script_label": "Pametni pisec video skript",
  "svc_ai-video-script_desc": "YouTube, TikTok in reklamne skripte",
  "admin_grp_dashboard": "Nadzorna plošča",
  "admin_grp_users": "Uporabniki in dostop",
  "admin_grp_analytics": "Analitika in poročila",
  "admin_grp_services": "Storitve in cene",
  "admin_grp_crypto": "Kripto in DeFi",
  "admin_grp_leads": "Potencialne stranke",
  "admin_grp_content": "Vsebina",
  "admin_grp_comm": "Komunikacija",
  "admin_grp_social": "Družbena omrežja",
  "admin_grp_ai": "AI in avtomatizacija",
  "admin_grp_design": "Oblikovanje in blagovna znamka",
  "admin_grp_system": "Sistem",
  "admin_grp_projects": "Projekti in testiranje",
  "color_palette_professional": "Profesionalno",
  "color_palette_playful": "Razigrano",
  "color_palette_luxury": "Luksuz",
  "color_palette_nature": "Narava",
  "color_palette_tech": "Tehnologija",
  "color_palette_warm": "Toplo",
  "color_palette_cool": "Hladno",
  "blog_translating": "Prevajanje članka...",
  "blog_translated_cached": "Prevedeno",
  "blog_translated_fresh": "Pravkar prevedeno",
  "blog_show_original": "Prikaži izvirnik",
  "privacy_s1_content": "Zbiramo informacije, ki nam jih neposredno posredujete, vključno z:\n- **Podatki o računu**: Ime, e-pošta in geslo pri ustvarjanju računa.\n- **Zahteve za storitve**: Podrobnosti projekta, proračun in kontaktni podatki.\n- **Podatki o plačilih**: Podatki, obdelani preko naših partnerjev (Stripe, myPOS).\n- **Komunikacijski podatki**: Sporočila preko RisTA, kontaktni obrazci in e-pošta.\n- **Podatki o uporabi**: Vrsta brskalnika, IP naslov, obiskane strani.",
  "privacy_s2_content": "Zbrane informacije uporabljamo za:\n- Zagotavljanje, vzdrževanje in izboljšanje naših storitev\n- Obdelavo transakcij\n- Pošiljanje tehničnih obvestil in podpore\n- Odgovarjanje na vaša vprašanja\n- Spremljanje trendov in aktivnosti\n- Odkrivanje in preprečevanje goljufij\n- Personalizacijo vaše izkušnje z RisTA",
  "privacy_s3_content": "Vaših osebnih podatkov ne prodajamo. Informacije lahko delimo z:\n- **Ponudniki storitev**: Podjetja, ki izvajajo storitve v našem imenu.\n- **Pravne zahteve**: Ko to zahteva zakon.\n- **Poslovni prenosi**: V povezavi z združitvami ali prodajami.\n- **Soglasje**: Z vašim izrecnim soglasjem.",
  "privacy_s4_content": "Izvajamo standardne varnostne ukrepe:\n- Šifriranje podatkov med prenosom (TLS/SSL) in v mirovanju\n- Podpora za dvofaktorsko avtentikacijo (2FA)\n- Redne varnostne revizije\n- Nadzor dostopa in avtentikacija\n- Varna obdelava plačil",
  "privacy_s5_content": "V skladu z veljavno zakonodajo (vključno z GDPR) imate pravico do:\n- **Dostop**: Zahtevajte kopijo vaših osebnih podatkov\n- **Popravek**: Zahtevajte popravek netočnih podatkov\n- **Izbris**: Zahtevajte izbris vaših podatkov\n- **Omejitev**: Zahtevajte omejitev obdelave\n- **Prenosljivost**: Zahtevajte prenos v strojno berljivem formatu\n- **Ugovor**: Ugovarjajte obdelavi\n- **Preklic soglasja**: Prekličite soglasje kadarkoli\n\nKontaktirajte nas: privacy@infinitybusiness.org.",
  "privacy_s6_content": "Uporabljamo bistvene piškotke za vašo sejo in nastavitve. Piškotke lahko upravljate preko brskalnika.",
  "privacy_s7_content": "Vaše podatke hranimo le toliko časa, kolikor je potrebno za namene zbiranja.",
  "privacy_s8_content": "Vaši podatki se lahko prenesejo zunaj EGP. Zagotavljamo ustrezne zaščitne ukrepe.",
  "privacy_s9_content": "To politiko zasebnosti lahko občasno posodobimo. Bistvene spremembe bodo objavljene na tej strani.",
  "privacy_s10_content": "Za vprašanja se obrnite na:\n\n**Liber Nostra d.o.o.**\nE-pošta: privacy@infinitybusiness.org\nSplet: infinitybusiness.org",
  "terms_s1_content": "Dobrodošli na Infinity Business (\"infinitybusiness.org\"), ki ga upravlja **Liber Nostra d.o.o.**. Z dostopom do naše platforme se strinjate s temi Pogoji.",
  "terms_s2_content": "Infinity Business ponuja digitalne storitve z umetno inteligenco:\n- Spletni razvoj, mobilne aplikacije in grafično oblikovanje (B2B)\n- Poslovne in digitalne oglaševalske storitve\n- Kripto izobraževanje, naložbena orodja in DeFi (P2P)\n- AI asistent RisTA\n- Domene in spletno gostovanje",
  "terms_s3_content": "Za določene funkcije morate ustvariti račun. Odgovorni ste za zaupnost svojih poverilnic.",
  "terms_s4_content": "Storitve lahko zahtevajo plačilo. Plačila preko tretjih oseb (Stripe, PayPal, kripto). Politika vračil:\n- **Enkratne storitve**: Nevračljive.\n- **Naročnine**: Možna odpoved kadarkoli.\n- **Prilagojeni projekti**: Po individualnem dogovoru.",
  "terms_s5_content": "Naš AI asistent \"RisTA\" zagotavlja avtomatizirano svetovanje. Samo v informativne namene.",
  "terms_s6_content": "Vsa vsebina na tej platformi je last podjetja Liber Nostra d.o.o.",
  "terms_s7_content": "Vašo uporabo ureja tudi naša Politika zasebnosti.",
  "terms_s8_content": "Storitve, povezane s kriptovalutami, so samo informativne. Ne nudimo finančnih nasvetov.",
  "terms_s9_content": "Liber Nostra d.o.o. ne odgovarja za posredne ali posledične škode.",
  "terms_s10_content": "Pridržujemo si pravico do spremembe teh Pogojev kadarkoli.",
  "terms_s11_content": "Ti Pogoji se urejajo po zakonodaji Republike Slovenije.",
  "terms_s12_content": "Za vprašanja nas kontaktirajte ali pišite na support@infinitybusiness.org.",
  "admin_ad_generator": "Generator oglasov",
  "admin_add": "Dodaj",
  "admin_add_prompt": "Dodaj Prompt",
  "admin_admin": "Admin",
  "admin_advanced_reporting": "Napredno poročanje",
  "admin_all": "Vse",
  "admin_analytics_dashboard": "Analitična nadzorna plošča",
  "admin_api_key": "API ključ",
  "admin_apply": "Uporabi",
  "admin_approved": "Odobreno",
  "admin_archive": "Arhiviraj",
  "admin_are_you_sure": "Ste prepričani?",
  "admin_audit_alerts": "Revizijska opozorila",
  "admin_author": "Avtor",
  "admin_avg_session": "Povprečna seja",
  "admin_back": "Nazaj",
  "admin_badge": "Značka",
  "admin_balance": "Stanje",
  "admin_banned": "Onemogočen",
  "admin_blog_manager": "Upravitelj bloga",
  "admin_body": "Telo",
  "admin_bounce_rate": "Stopnja odboja",
  "admin_browser": "Brskalnik",
  "admin_campaign": "Kampanja",
  "admin_cannot_undo": "Tega dejanja ni mogoče razveljaviti",
  "admin_category": "Kategorija",
  "admin_click_rate": "Stopnja klikov",
  "admin_close": "Zapri",
  "admin_completed": "Dokončano",
  "admin_configuration": "Konfiguracija",
  "admin_confirm": "Potrdi",
  "admin_contact_info": "Kontaktni podatki",
  "admin_content": "Vsebina",
  "admin_conversations": "Pogovori",
  "admin_conversion_funnel": "Konverzijski lijak",
  "admin_conversion_rate": "Stopnja konverzije",
  "admin_copied": "Kopirano v odložišče",
  "admin_copy": "Kopiraj",
  "admin_count": "Število",
  "admin_country": "Država",
  "admin_create": "Ustvari",
  "admin_create_experiment": "Ustvari eksperiment",
  "admin_create_new": "Ustvari novo",
  "admin_created_success": "Uspešno ustvarjeno",
  "admin_credit_config": "Credit konfiguracija",
  "admin_critical": "Kritična",
  "admin_custom": "Po meri",
  "admin_daily": "Dnevno",
  "admin_date": "Datum",
  "admin_delete_failed": "Brisanje ni uspelo",
  "admin_deleted_success": "Uspešno izbrisano",
  "admin_demo_access": "Demo dostop",
  "admin_description": "Opis",
  "admin_deselect_all": "Počisti izbor",
  "admin_details": "Podrobnosti",
  "admin_device": "Naprava",
  "admin_disable": "Onemogoči",
  "admin_disabled": "Onemogočeno",
  "admin_doc_viewer": "Pregledovalnik dokumentov",
  "admin_documentation": "Dokumentacija",
  "admin_download": "Prenesi",
  "admin_draft": "Onutek",
  "admin_duplicate": "Podvoji",
  "admin_email": "Email",
  "admin_enable": "Omogoči",
  "admin_enabled": "Omogočeno",
  "admin_end_date": "Datum konca",
  "admin_endpoint": "Endpoint",
  "admin_error": "Napaka",
  "admin_escalation_queue": "Vrsta za eskalacijo",
  "admin_event": "Dogodek",
  "admin_events": "Dogodki",
  "admin_experiment_name": "Ime eksperimenta",
  "admin_export": "Izvozi",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "Napačno",
  "admin_filter": "Filtriraj",
  "admin_frequency": "Pogostost",
  "admin_generate": "Generiraj",
  "admin_headers": "Glave",
  "admin_health_monitoring": "Spremljanje stanja",
  "admin_high": "Visoka",
  "admin_high_value_leads": "Visoko vredni vodiči",
  "admin_id": "ID",
  "admin_image": "Slika",
  "admin_import": "Uvozi",
  "admin_in_progress": "V teku",
  "admin_inactive": "Neaktivno",
  "admin_inbox": "Admin Prejeto",
  "admin_speed_audit": "Pregled hitrosti",
  "admin_info": "Info",
  "admin_ip_address": "IP naslov",
  "admin_joined": "Pridružen",
  "admin_knowledge_base": "Baza znanja",
  "admin_language": "Jezik",
  "admin_last_activity": "Zadnja aktivnost",
  "admin_last_login": "Zadnja prijava",
  "admin_last_triggered": "Zadnjič sproženo",
  "admin_lead_score": "Lead Score",
  "admin_level": "Raven",
  "admin_load_failed": "Nalaganje ni uspelo",
  "admin_loading_data": "Nalaganje podatkov...",
  "admin_low": "Nizka",
  "admin_medium": "Srednja",
  "admin_messages": "Sporočila",
  "admin_method": "Metoda",
  "admin_monetization": "Monetizacija",
  "admin_monthly": "Mesečno",
  "admin_name": "Ime",
  "admin_next": "Naprej",
  "admin_no": "Ne",
  "admin_no_data_available": "Podatki niso na voljo",
  "admin_no_experiments": "Ni najdenih eksperimentov",
  "admin_no_leads": "Ni najdenih leadov",
  "admin_no_prompts": "Ni najdenih promptov",
  "admin_no_results": "Ni rezultatov",
  "admin_no_results_found": "Ni najdenih rezultatov",
  "admin_none": "Brez",
  "admin_off": "Izključeno",
  "admin_on": "Vključeno",
  "admin_open_rate": "Stopnja odpiranja",
  "admin_page_views": "Ogledi strani",
  "admin_partner_badges": "Partnerske značke",
  "admin_payload": "Payload",
  "admin_payment_options": "Možnosti plačila",
  "admin_platform": "Platforma",
  "admin_platform_audit": "Revizija platforme",
  "admin_points": "Točke",
  "admin_portfolio_manager": "Upravitelj portfelja",
  "admin_preloader_config": "Preloader konfiguracija",
  "admin_preview": "Predogled",
  "admin_previous": "Nazaj",
  "admin_price": "Cena",
  "admin_priority": "Prioriteta",
  "admin_prompt_name": "Ime prompta",
  "admin_prompt_text": "Besedilo prompta",
  "admin_published": "Objavljeno",
  "admin_recipients": "Prejemniki",
  "admin_referral": "Referral",
  "admin_referral_leaderboard": "Lestvica priporočil",
  "admin_refresh": "Osveži",
  "admin_rejected": "Zavrnjeno",
  "admin_remove": "Odstrani",
  "admin_reset": "Ponastavi",
  "admin_response_time": "Odzivni čas",
  "admin_restore": "Obnovi",
  "admin_results": "Rezultati",
  "admin_retry": "Poskusi znova",
  "admin_revenue_dashboard": "Nadzorna plošča prihodkov",
  "admin_rista_services": "RisTA storitve",
  "admin_role": "Vloga",
  "admin_save_changes": "Shrani spremembe",
  "admin_save_failed": "Shranjevanje ni uspelo",
  "admin_saved_success": "Uspešno shranjeno",
  "admin_scheduled": "Načrtovano",
  "admin_search": "Išči",
  "admin_select": "Izberi",
  "admin_select_all": "Izberi vse",
  "admin_send": "Pošlji",
  "admin_sent_success": "Uspešno poslano",
  "admin_server_resources": "Strežniški viri",
  "admin_service_manager": "Upravitelj storitev",
  "admin_session_duration": "Trajanje seje",
  "admin_settings": "Nastavitve",
  "admin_slug": "Slug",
  "admin_social_automation": "Avtomatizacija družbenih omrežij",
  "admin_something_wrong": "Nekaj je šlo narobe",
  "admin_source": "Vir",
  "admin_start_date": "Datum začetka",
  "admin_subject": "Zadeva",
  "admin_submit": "Pošlji",
  "admin_subscribers": "Naročniki",
  "admin_success": "Uspeh",
  "admin_suspended": "Suspendiran",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "Oznake",
  "admin_template": "Predloga",
  "admin_templates": "Predloge",
  "admin_test_results": "Rezultati testov",
  "admin_tester_program": "Program za testerje",
  "admin_title": "Naslov",
  "admin_total_revenue": "Skupni prihodek",
  "admin_total_sessions": "Skupno sej",
  "admin_total_users": "Skupno uporabnikov",
  "admin_trigger": "Sprožilec",
  "admin_true": "Pravilno",
  "admin_try_again": "Prosimo, poskusite znova",
  "admin_type": "Vrsta",
  "admin_unique_visitors": "Edinstveni obiskovalci",
  "admin_unsubscribed": "Odjavljeni",
  "admin_unverified": "Nepreverjen",
  "admin_update": "Posodobi",
  "admin_updated_success": "Uspešno posodobljeno",
  "admin_upload": "Naloži",
  "admin_urgent": "Nujno",
  "admin_user": "Uporabnik",
  "admin_variant_a": "Variant A",
  "admin_variant_b": "Variant B",
  "admin_verified": "Preverjen",
  "admin_version": "Verzija",
  "admin_view": "Poglej",
  "admin_view_details": "Ogled podrobnosti",
  "admin_viewer": "Gledalec",
  "admin_warning": "Opozorilo",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Tedensko",
  "admin_yes": "Da",
  "admin_analytics_digestadmin_analytics_digest": "Povzetek analitike",
  "admin_blog_health": "Zdravje bloga",
  "credit_title": "Krediti",
  "credit_subtitle": "Predplačnino stanje za inteligentne storitve",
  "credit_available_balance": "Razpoložljivo stanje",
  "credit_tab_balance": "Stanje",
  "credit_tab_topup": "Dopolni",
  "credit_tab_history": "Zgodovina",
  "credit_tab_services": "Storitve",
  "credit_tab_crypto": "Kripto",
  "credit_balance_desc": "Vaš kredit se lahko uporabi za katero koli AI storitev:",
  "credit_bulk_discounts": "Količinski popusti",
  "credit_add_credits": "Dodaj kredite",
  "credit_select_amount": "Izberite znesek ali vnesite vrednost:",
  "credit_bonus": "bonus",
  "credit_bonus_detail": "Dobili boste",
  "credit_total_word": "skupaj",
  "credit_method_card": "Kartica",
  "credit_method_crypto": "Kripto",
  "credit_processing": "Obdelava...",
  "credit_add_btn": "Dodaj",
  "credit_no_txn": "Ni transakcij",
  "credit_txn_topup": "Dopolnitev",
  "credit_txn_promo": "Promo kredit",
  "credit_txn_auto": "Samodejni nakup",
  "credit_txn_purchase": "Nakup",
  "credit_svc_intelligent": "Inteligentna storitev",
  "credit_svc_available": "Na voljo",
  "credit_svc_need_more": "Potrebujete",
  "credit_svc_more": "več",
  "credit_crypto_send": "Pošlji",
  "credit_crypto_amount": "Znesek:",
  "credit_crypto_equivalent": "ekvivalent",
  "credit_crypto_network": "Omrežje:",
  "credit_crypto_wallet": "Naslov denarnice",
  "credit_crypto_confirm": "Krediti bodo dodani po potrditvi transakcije.",
  "credit_payment_id": "ID plačila:",
  "credit_crypto_back": "Nazaj na izbiro kriptovalute",
  "credit_crypto_select_title": "Izberite kriptovaluto za dopolnitev",
  "credit_crypto_choose_desc": "Izberite kovanec. Prejeli boste naslov denarnice za plačilo.",
  "credit_crypto_select_btn": "Izberi",
  "credit_minimum": "Minimum €5",
  "credit_redirecting": "Preusmerjanje...",
  "credit_topup_failed": "Dopolnitev neuspešna",
  "credit_crypto_failed": "Kripto plačilo ni uspelo",
  "cart_title": "Košarica",
  "cart_total": "Skupaj",
  "cart_stripe_checkout": "Stripe plačilo",
  "cart_credits": "Krediti",
  "cart_secure_stripe": "Varno Stripe plačilo",
  "cart_insufficient": "Nezadostni krediti. Najprej dopolnite ali izberite plačilo s kartico.",
  "cart_pay_card": "Plačaj s kartico",
  "cart_pay_credits_btn": "Plačaj s krediti",
  "cart_clear": "Izprazni košarico",
  "cart_processing": "Obdelava...",
  "cart_payment_success": "Plačilo uspešno! Vaše naročilo se obdeluje.",
  "cart_complete_setup": "Dokončajte nastavitve",
  "cart_also_added": "Stranke s podobnimi nakupi so dodale tudi:",
  "cart_add": "Dodaj",
  "cart_standard": "Standard",
  "cart_remaining_balance": "Preostalo stanje:",
  "cart_checkout_failed": "Plačilo neuspešno",
  "cart_checkout_no_session": "Ni mogoče ustvariti seje plačila",
  "cart_purchased": "Kupljeno",
  "cart_services_with_credits": "storitev(-e) s krediti!",
  "credits_balance_title": "Stanje kreditov",
  "credits_topup_btn": "Dopolni kredite",
  "credits_rate": "1 EUR = 1 Kredit",
  "credits_total_topup": "Skupaj dopolnjeno",
  "credits_spent_credits": "Porabljeno (Krediti)",
  "credits_spent_payments": "Porabljeno (Plačila)",
  "credits_txn_history": "Zgodovina transakcij",
  "credits_no_txn": "Ni transakcij",
  "credits_txn_topup": "Dopolnitev",
  "credits_txn_promo": "Promo kredit",
  "credits_txn_purchase": "Nakup storitve",
  "credits_txn_ai": "AI storitev",
  "credits_order_history": "Zgodovina naročil",
  "credits_order_label": "Naročilo:",
  "chat_translate_btn": "Prevedi v angleščino",
  "chat_translating": "Prevajanje...",
  "chat_translated_label": "Prikazan je angleški prevod. Kliknite \"Prikaži izvirnik\" za izvirna sporočila.",
  "chat_show_original": "Prikaži izvirnik",
  "chat_show_translated": "Prikaži prevod",
  "pkg_section_badge": "Omejene ponudbe",
  "pkg_section_title": "Začnite svoje poslovanje",
  "pkg_section_title_highlight": "Danes",
  "pkg_section_subtitle": "Premium paketi, zasnovani za hitro prenos na spletu — s pametno tehnologijo, vgrajeno od prvega dne.",
  "pkg_section_footer": "Vse cene ne vključujejo DDV-ja, kjer je to primerno. Niste prepričani, kateri paket ustreza? Pogovarjajte se z RisTA za brezplačno svetovanje.",
  "pkg_cta_default": "Začnite",
  "admin_package_mgr": "Upravitelj paketov",
  "admin_pkg_title": "Paketi ciljnih strani",
  "admin_pkg_subtitle": "Upravljajte izpostavljene cenovne pakete, prikazane na ciljnih straneh",
  "admin_pkg_seed": "Privzete vrednosti",
  "admin_pkg_new": "Nov paket",
  "admin_pkg_create_title": "Ustvari nov paket",
  "admin_pkg_edit_title": "Uredi paket",
  "admin_pkg_name": "Ime paketa",
  "admin_pkg_tagline": "Slogan",
  "admin_pkg_description": "Opis",
  "admin_pkg_price": "Cena",
  "admin_pkg_currency": "Valuta",
  "admin_pkg_price_note": "Opomba o ceni",
  "admin_pkg_badge": "Značka",
  "admin_pkg_accent": "Barva akcenta",
  "admin_pkg_cta_text": "Besedilo CTA gumba",
  "admin_pkg_cta_link": "CTA povezava (neobvezno)",
  "admin_pkg_sort": "Vrstni red",
  "admin_pkg_features": "Funkcije / Vključene storitve",
  "admin_pkg_add_feature": "Dodaj funkcijo",
  "admin_pkg_highlighted": "Izpostavljeno",
  "admin_pkg_normal": "Normalno",
  "admin_pkg_create": "Ustvari paket",
  "admin_pkg_save": "Shrani spremembe",
  "admin_pkg_saving": "Shranjujem...",
  "admin_pkg_cancel": "Prekliči",
  "admin_pkg_empty_title": "Še ni konfiguriranih paketov",
  "admin_pkg_empty_desc": "Kliknite na Privzete vrednosti za generiranje dveh začetnih paketov ali ustvarite svoje.",
  "admin_pkg_features_label": "funkcije",
  "admin_pkg_sort_label": "Vrstni red",
  "admin_pkg_delete_confirm": "Izbrisati ta paket? Odstranil se bo s ciljne strani.",
  "admin_pkg_feature_placeholder": "Opis funkcije...",
  "admin_pkg_pricenote_placeholder": "npr. Enkratno / +5% delež prihodkov",
  "admin_pkg_badge_placeholder": "npr. NAJBOLJŠA VREDNOST",
  "admin_pkg_loading": "Nalaganje paketov...",
  "pkg_qa_have_domain": "Da, imam domeno",
  "pkg_qa_need_domain": "Potrebujem domeno",
  "pkg_qa_describe_biz": "Naj opišem svojo dejavnost",
  "pkg_qa_more_info": "Povejte mi več o tem paketu",
  "sp_addon_title": "Dodatki in podpora",
  "sp_addon_desc": "Okrepite svoj projekt s prednostno podporo in strokovnim svetovanjem.",
  "sp_research_title": "Pametni raziskovalni produkti",
  "sp_research_desc": "Tržna inteligenca na zahtevo in orodja za pametno analizo.",
  "tier_section_badge": "Pametni paketi",
  "tier_section_title": "Izberite svoj",
  "tier_section_highlight": "Načrt rasti",
  "tier_section_subtitle": "Paketi zasnovani za maksimalno vrednost. Izberite raven, ki vam ustreza.",
  "tier_one_time": "Enkratno",
  "tier_monthly": "Mesečno",
  "tier_section_footer": "Vse cene so brez DDV. Potrebujete prilagojen paket? Klepetajte z RisTA.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Idealno za začetek vaše digitalne prisotnosti",
  "tier_tag_growth": "Povečajte poslovanje s pametnimi orodji",
  "tier_tag_pro": "Popolna digitalna rast za resna podjetja",
  "tier_tag_enterprise": "Popolna digitalna preobrazba",
  "tier_cta_starter": "Izberi Starter",
  "tier_cta_growth": "Izberi Growth",
  "tier_cta_pro": "Izberi Pro",
  "tier_cta_enterprise": "Izberi Enterprise",
  "tier_badge_popular": "PRILJUBLJENO",
  "tier_badge_best": "NAJBOLJŠA VREDNOST",
  "tier_badge_all": "VSE V ENEM",
  "tier_per_mo": "mes.",
  "tier_once_label": "enkratno",
  "tier_or_monthly": "ali",
  "tier_f_starter_1": "Pametni generator poslovnega načrta",
  "tier_f_starter_2": "Pametni graditelj življenjepisa (3 kos.)",
  "tier_f_starter_3": "Revizija spletne strani in SEO poročilo",
  "tier_f_starter_4": "Pameten logotip in paket blagovne znamke",
  "tier_f_starter_5": "Poročilo pregleda trga",
  "tier_f_starter_6": "Osnutek FAQ odgovorov",
  "tier_f_starter_7": "Oris bloga iz trenda",
  "tier_f_starter_8": "Email podpora v 48 urah",
  "tier_f_growth_1": "Vse iz Starterja",
  "tier_f_growth_2": "Pametna email kampanja",
  "tier_f_growth_3": "Koledar in analiza družbenih omrežij (3 mes.)",
  "tier_f_growth_4": "Poročilo analize konkurence",
  "tier_f_growth_5": "Generator oglasov (5 kampanj)",
  "tier_f_growth_6": "Generator dosežnih emailov",
  "tier_f_growth_7": "Razlagalec trendov",
  "tier_f_growth_8": "Analiza pozicioniranja",
  "tier_f_growth_9": "Prednostna email podpora v 24 urah",
  "tier_f_pro_1": "Vse iz Growtha",
  "tier_f_pro_2": "SEO in digitalni marketing nastavitev",
  "tier_f_pro_3": "Email marketing nastavitev",
  "tier_f_pro_4": "Pameten pisec video skript (5 kos.)",
  "tier_f_pro_5": "Hitra TAM logična skica",
  "tier_f_pro_6": "Kontrolni seznam tveganj",
  "tier_f_pro_7": "Prednostno razvrščanje funkcij",
  "tier_f_pro_8": "Osnutek seznama dobaviteljev",
  "tier_f_pro_9": "Pametna svetovalniška seja (2 uri)",
  "tier_f_pro_10": "Prednostna podpora v 12 urah",
  "tier_f_ent_1": "Vse iz Pro",
  "tier_f_ent_2": "Razvoj prilagojene programske opreme",
  "tier_f_ent_3": "Enterprise strategija oglaševanja",
  "tier_f_ent_4": "Upravljano gostovanje (12 mesecev)",
  "tier_f_ent_5": "Načrt vzdrževanja (6 mesecev)",
  "tier_f_ent_6": "Pametno svetovanje (10 ur)",
  "tier_f_ent_7": "Preverjanje vstopa na trg",
  "tier_f_ent_8": "Izvršni povzetek za predstavitve",
  "tier_f_ent_9": "JTBD izjava problema",
  "tier_f_ent_10": "Posvečen skrbnik računa",
  "tier_f_ent_11": "Prednostna čakalna vrsta (odgovor 4h)",
  "calc_title": "Kalkulator cen",
  "calc_subtitle": "Primerjajte posamezne storitve s paketi za ogled prihrankov.",
  "calc_badge": "Prihranite več",
  "calc_select_services": "Izberite storitve",
  "calc_search_placeholder": "Iščite storitve...",
  "calc_selected": "izbranih",
  "calc_your_selection": "Vaša izbira",
  "calc_individual_total": "Posamezni skupaj",
  "calc_best_tier": "Najboljši ustrezen paket",
  "calc_you_save": "Prihranite",
  "calc_no_services": "Izberite storitve za prikaz prihrankov",
  "calc_clear_all": "Počisti vse",
  "calc_get_tier": "Pridobi ta paket",
  "calc_individual_cheaper": "Posamezne storitve so že ugodne. Dodajte več za paketne prihranke!",
  "referred_by": "Priporocilo od",
  "referral_signup_reward": "Registrirajte se, da povežete račun s to napotitvijo.",
  "badge_coming_soon": "Kmalu na voljo",
  "badge_available_soon": "Kmalu na voljo",
  "badge_from_price": "od",
  "badge_preparing": "Pripravljamo to storitev za vas",
  "svc_managed-hosting_label": "Upravljano gostovanje",
  "svc_managed-hosting_desc": "Popolnoma upravljano gostovanje z nadzorom in podporo",
  "svc_enterprise-advertising_label": "Poslovno oglaševanje",
  "svc_enterprise-advertising_desc": "Obsežne oglaševalske kampanje z namensko strategijo",
  "svc_email-marketing_label": "Nastavitev e-poštnega marketinga",
  "svc_email-marketing_desc": "Profesionalna e-poštna zaporedja, predloge in avtomatizacija",
  "svc_competitor-analysis_label": "Poročilo o analizi konkurence",
  "svc_competitor-analysis_desc": "Tržna inteligenca in konkurenčno pozicioniranje",
  "svc_legal-docs_label": "Generator pravnih dokumentov",
  "svc_legal-docs_desc": "NDA, pogodbe, predloge pogojev uporabe",
  "svc_website-audit_label": "Revizija spletne strani in SEO poročilo",
  "svc_website-audit_desc": "Celovita analiza spletne strani s priporočili",
  "svc_trading-consultation_label": "Posvetovanja o trgovanju",
  "svc_trading-consultation_desc": "Strokovno vodene seje strategije trgovanja",
  "svc_managed-trading_label": "Upravljano trgovanje",
  "svc_managed-trading_desc": "Strokovno upravljano trgovanje z preverjenimi strategijami",
  "svc_domain-management_label": "Upravljanje domen",
  "svc_domain-management_desc": "Registracija domen, upravljanje DNS in prenosi",
  "svc_personal-branding_label": "Osebna blagovna znamka",
  "svc_personal-branding_desc": "Zgradite svojo spletno prisotnost in osebno blagovno znamko",
  "admin_escalation_alert": "Eskalacija pogovora",
  "admin_view_escalations": "Ogled čakalne vrste eskalacij",
  "from": "Od",
  "vector_gen_title": "Pametni vektorski",
  "vector_gen_title_hl": "Generator",
  "vector_gen_badge": "Pametni vektorski studio",
  "vector_gen_desc": "Opišite svojo idejo, naložite reference in v nekaj sekundah pridobite produkcijsko pripravljeno SVG vektorsko grafiko.",
  "vector_gen_balance": "Vaše stanje",
  "vector_gen_per_gen": "kreditov na generiranje",
  "vector_gen_prompt_label": "Opišite svojo vektorsko grafiko",
  "vector_gen_prompt_ph": "npr. Minimalistični logotip gore s sončnimi žarki, v turkizni in oranžni barvi...",
  "vector_gen_style": "Slog",
  "vector_gen_color": "Barvni način",
  "vector_gen_refs": "Referenčne datoteke",
  "vector_gen_optional": "neobvezno, največ 3",
  "vector_gen_upload": "Naloži referenco (PNG, JPG, SVG)",
  "vector_gen_generating": "Generiranje...",
  "vector_gen_cta": "Generiraj vektor",
  "vector_gen_result": "Vaša vektorska grafika",
  "vector_gen_model_used": "Model",
  "vector_gen_history": "Zgodovina generiranja",
  "vector_gen_no_history": "Še ni generiranj",
  "vector_gen_login_req": "Prijavite se za uporabo vektorskega generatorja.",
  "vector_gen_service_title": "Potrebujete profesionalne vektorje?",
  "vector_gen_service_desc": "Naročite prilagojene vektorske grafike kot popolno oblikovalsko storitev z revizijami in smernicami blagovne znamke.",
  "vector_gen_service_cta": "Oglejte si oblikovalske storitve",
  "vector_gen_product_type": "Vrsta izdelka",
  "vector_gen_size": "Velikost izhoda",
  "vector_gen_error_prompt": "Prosimo, opišite svojo idejo za vektorsko grafiko.",
  "admin_vector_gen": "Vektorski generator",
  "admin_showroom": "Razstavni prostor",
  "admin_landing_page": "Ciljna stran",
  "admin_landing_text": "Besedila ciljne strani",
  "admin_vector_title": "Vektorski generator",
  "admin_vector_models": "Razpoložljivi modeli",
  "admin_vector_pricing": "Cene in omejitve",
  "svc_vector-generator_label": "Pametni vektorski generator",
  "svc_vector-generator_desc": "Generirajte produkcijsko pripravljene SVG vektorske grafike iz besedilnih opisov",
  "sp_vector_gen_name": "Pametni vektorski generator",
  "sp_vector_gen_desc": "Generirajte SVG vektorske grafike iz besedilnih opisov s pametno tehnologijo.",
  "sp_vector_gen_feat": "Generiranje besedilo-v-vektor|Izvoz SVG in PNG|Več slogovnih predlog|Vgrajeni SVG urejevalnik|Nalaganje referenc|Cene na osnovi kreditov",
  "sp_managed_hosting_name": "Upravljano gostovanje",
  "sp_managed_hosting_feat": "24/7 nadzor|Samodejne posodobitve|Upravljanje SSL|Dnevne varnostne kopije|Optimizacija|Namenjena podpora",
  "sp_enterprise_ad_name": "Podjetniško oglaševanje",
  "sp_enterprise_ad_feat": "Strategija kampanje|Večkanalno|A/B testiranje|Sledenje|Namenski upravitelj|Poročila",
  "sp_email_marketing_name": "Postavitev email marketinga",
  "sp_email_marketing_feat": "Email sekvence|Oblikovanje predlog|Avtomatizacija|Upravljanje seznamov|Analitika|A/B testiranje",
  "sp_competitor_analysis_name": "Poročilo analize konkurence",
  "sp_competitor_analysis_feat": "Analiza trga|Profili konkurentov|SWOT|Primerjava cen|Priporočila|Posodobitve",
  "sp_website_audit_name": "Revizija spletne strani in SEO poročilo",
  "sp_website_audit_feat": "Tehnična revizija|SEO analiza|Metriki|Dostopnost|Varnostno skeniranje|Akcijski načrt",
  "sp_defi_name": "DeFi rešitve",
  "sp_defi_feat": "Pametne pogodbe|Pridelava donosa|Likvidnostni bazeni|DeFi revizija|Ustvarjanje žetonov|Rešitve za zastavljanje",
  "sp_personal_brand_name": "Osebna blagovna znamka",
  "sp_personal_brand_feat": "Strategija blagovne znamke|Prisotnost na družbenih omrežjih|Osebna spletna stran|Načrtovanje vsebine|Profesionalne fotografije|Pisanje biografije",
  "sp_ad_gen_name": "Generator oglasov",
  "sp_ad_gen_feat": "Oglasna besedila|Kreativni formati|Več platform|A/B različice|Ciljanje občinstva|Nasveti za učinkovitost",
  "sp_priority_name": "Prednostna vrsta",
  "sp_priority_feat": "Odgovor v 4 urah|Namenski kanal|Prednostna obdelava|Posodobitve statusa|SLA garancija|Razširjena podpora",
  "sp_maintenance_name": "Načrt vzdrževanja",
  "sp_maintenance_feat": "Mesečne posodobitve|Varnostni popravki|Spremljanje učinkovitosti|Popravki napak|Garancija razpoložljivosti|Prednostna podpora",
  "sp_consulting_name": "Pametna svetovalna seja",
  "sp_consulting_feat": "Strokovno svetovanje|Strateška seja|Tehnični nasveti|Načrt implementacije|Zapisi po seji|Posnetek vključen",
  "sp_market_snapshot_name": "Pregled trga",
  "sp_market_snapshot_feat": "Pregled trga|Ključni trendi|Konkurenčno okolje|Priložnosti za rast|Dejavniki tveganja|Izvršni povzetek",
  "sp_trend_explainer_name": "Razlaga trendov",
  "sp_trend_explainer_feat": "Analiza trendov|Vpliv na panogo|Ocena priložnosti|Časovna projekcija|Akcijski koraki|Vizualno poročilo",
  "sp_competitor_qa_name": "Vprašanja o konkurenci",
  "sp_competitor_qa_feat": "Analiza strategije|Cenovni vpogledi|Tržno pozicioniranje|Primerjava funkcij|Analiza slabosti|Zemljevid priložnosti",
  "sp_country_entry_name": "Preverjanje vstopa na trg",
  "sp_country_entry_feat": "Pripravljenost trga|Regulatorni pregled|Kulturni dejavniki|Analiza konkurence|Strategija vstopa|Ocena tveganja",
  "sp_vendor_shortlist_name": "Kratka lista ponudnikov",
  "sp_vendor_shortlist_feat": "Raziskava ponudnikov|Primerjalna matrika|Analiza cen|Ocena zmogljivosti|Priporočila|Kontaktni podatki",
  "sp_tam_logic_name": "Skica TAM logike",
  "sp_tam_logic_feat": "Ocena TAM|Razčlenitev SAM/SOM|Logični okvir|Viri podatkov|Predpostavke rasti|Vizualna predstavitev",
  "sp_positioning_name": "Strategija pozicioniranja",
  "sp_positioning_feat": "Tržno pozicioniranje|Segmentacija občinstva|Vrednostna ponudba|Okvir sporočil|Diferenciacija|Konkurenčna prednost",
  "sp_managed_trading_name": "Upravljano trgovanje",
  "sp_managed_trading_feat": "Upravljanje portfelja|Upravljanje tveganj|Preizkušene strategije|Redna poročila|Namenski upravitelj|Analiza trga",
  "sp_trading_consult_name": "Posvetovanje o trgovanju",
  "sp_trading_consult_feat": "Individualne seje|Razvoj strategije|Analiza trga|Ocena tveganja|Pregled portfelja|Strokovno vodstvo",
  "sp_domains_name": "LiveDomain trg",
  "sp_domains_feat": "Premium domene|Aftermarket ponudbe|Vrednotenje domen|Podpora za prenos|Pogajanje|Upravljanje portfelja",
  "sp_domain_mgmt_name": "Upravljanje domen",
  "sp_domain_mgmt_feat": "Upravljanje DNS|Samodejno podaljšanje|Podpora za prenos|Sledenje portfelja|SSL certifikati|Whois zasebnost",
  "sp_managed_hosting_desc": "Popolnoma upravljano gostovanje z nadzorom, posodobitvami in namensko podporo.",
  "sp_enterprise_ad_desc": "Obsežne oglaševalske kampanje z namensko strategijo in upravljanjem.",
  "sp_email_marketing_desc": "Profesionalne email sekvence, predloge in avtomatizacija marketinga.",
  "sp_competitor_analysis_desc": "Poglobljena tržna analiza in konkurenčno pozicioniranje.",
  "sp_website_audit_desc": "Celovita analiza spletnega mesta z izvedljivimi priporočili.",
  "sp_managed_trading_desc": "Strokovno upravljano trgovanje z preizkušenimi strategijami in upravljanjem tveganj.",
  "sp_trading_consult_desc": "Individualne seje o trgovalni strategiji pod vodstvom strokovnjakov.",
  "sp_domains_desc": "Pridobivanje premium domen in ponudbe na sekundarnem trgu.",
  "sp_domain_mgmt_desc": "Upravljanje DNS, podaljšanja, prenosi in skrb za portfelj domen.",
  "sp_defi_desc": "Pametne pogodbe, pridelava donosa in rešitve za likvidnostne bazene.",
  "sp_personal_brand_desc": "Zgradite svojo spletno prisotnost in identiteto osebne blagovne znamke.",
  "sp_ad_gen_desc": "Takoj ustvarite visoko konverzijske oglasne besedila in kreative.",
  "sp_priority_desc": "Zagotovljen odgovor v 4 urah.",
  "sp_maintenance_desc": "Tekoče vzdrževanje, posodobitve in tehnična podpora.",
  "sp_consulting_desc": "Individualno svetovanje z našimi strokovnjaki za pametne tehnologije.",
  "sp_market_snapshot_desc": "Hiter pregled tržne pokrajine in trendov.",
  "sp_trend_explainer_desc": "Razumite nastajajoče trende, relevantne za vašo panogo.",
  "sp_competitor_qa_desc": "Pridobite odgovore o strategijah vaših konkurentov.",
  "sp_country_entry_desc": "Ocenite pripravljenost trga za mednarodno širitev.",
  "sp_vendor_shortlist_desc": "Sestavljen seznam ponudnikov za vaše specifične potrebe.",
  "sp_tam_logic_desc": "Ocena celotnega naslovljivega trga z logičnim razčlenjevanjem.",
  "sp_positioning_desc": "Analiza strategije pozicioniranja produkta in občinstva.",
  "vector_gen_model": "Model",
  "vector_gen_quality": "Raven kakovosti",
  "svc_smart-resume_label": "Pametni ustvarjalec življenjepisa",
  "svc_smart-resume_desc": "ATS-optimizirani življenjepisi, ki jih ustvari naš pametni sistem",
  "svc_smart-business-plan_label": "Pametni generator poslovnega načrta",
  "svc_smart-business-plan_desc": "Celoten poslovni načrt s financami in analizo trga",
  "svc_smart-seo-report_label": "Pametno SEO poročilo",
  "svc_smart-seo-report_desc": "Avtomatizirana analiza spletnega mesta s priporočili",
  "svc_smart-brand-kit_label": "Pametni logotip in paket blagovne znamke",
  "svc_smart-brand-kit_desc": "Koncept logotipa, barvna paleta, tipografija in materiali za družbena omrežja",
  "svc_smart-email-campaign_label": "Pametna email kampanja",
  "svc_smart-email-campaign_desc": "Inteligentni email marketing z optimiziranimi sekvencami",
  "svc_smart-social-calendar_label": "Koledar in analiza družbenih omrežij",
  "svc_smart-social-calendar_desc": "30 dni pametno ustvarjenih objav s strategijo angažiranja",
  "svc_ad-generator_label": "Generator oglasov",
  "svc_ad-generator_desc": "Takoj ustvarite visoko konverzijske oglasne besedila",
  "svc_smart-translation_label": "Pametne prevajalske storitve",
  "svc_smart-translation_desc": "Profesionalno prevajanje dokumentov v 50+ jezikov",
  "svc_smart-video-script_label": "Pametni pisec video scenarijev",
  "svc_smart-video-script_desc": "YouTube, TikTok in oglasni scenariji, optimizirani za angažiranje",
  "svc_priority-queue_label": "Prednostna vrsta",
  "svc_priority-queue_desc": "Zagotovljen odgovor v 4 urah",
  "svc_maintenance-plan_label": "Načrt vzdrževanja",
  "svc_maintenance-plan_desc": "Tekoče vzdrževanje, posodobitve in tehnična podpora",
  "svc_smart-consulting_label": "Pametna svetovalna seja",
  "svc_smart-consulting_desc": "Individualno svetovanje z našimi tehnološkimi strokovnjaki",
  "svc_market-snapshot_label": "Pregled trga",
  "svc_market-snapshot_desc": "Hiter pregled tržne pokrajine",
  "svc_trend-explainer_label": "Razlaga trendov",
  "svc_trend-explainer_desc": "Razumite nastajajoče trende v vaši panogi",
  "svc_competitor-qa_label": "Vprašanja o konkurenci",
  "svc_competitor-qa_desc": "Odgovori o strategijah vaših konkurentov",
  "svc_country-entry-check_label": "Preverjanje vstopa na trg",
  "svc_country-entry-check_desc": "Ocena pripravljenosti trga za mednarodno širitev",
  "svc_should-i-care_label": "Preverjanje relevantnosti",
  "svc_should-i-care_desc": "Ocenite, ali je trend pomemben za vaše podjetje",
  "svc_report-matchmaker_label": "Iskalnik poročil",
  "svc_report-matchmaker_desc": "Poiščite pravo raziskovalno poročilo",
  "svc_which-region-first_label": "Regionalna prioriteta",
  "svc_which-region-first_desc": "Podatkovno podprte smernice za vstop na regionalni trg",
  "svc_vendor-shortlist_label": "Kratka lista ponudnikov",
  "svc_vendor-shortlist_desc": "Sestavljen seznam ponudnikov",
  "svc_forecast-explanation_label": "Razlaga napovedi",
  "svc_forecast-explanation_desc": "Jasna razlaga tržnih napovedi",
  "svc_outreach-email-gen_label": "Generator kontaktnih emailov",
  "svc_outreach-email-gen_desc": "Ustvarite personalizirane kontaktne emaile v obsegu",
  "svc_executive-summary_label": "Izvršni povzetek",
  "svc_executive-summary_desc": "Povzetki pripravljeni za predstavitve",
  "svc_faq-answer-draft_label": "Osnutek FAQ odgovorov",
  "svc_faq-answer-draft_desc": "Osnutki odgovorov na pogosta vprašanja",
  "svc_jtbd-problem_label": "JTBD izjava o problemu",
  "svc_jtbd-problem_desc": "Analiza problema po JTBD okviru",
  "svc_tam-logic-sketch_label": "Skica TAM logike",
  "svc_tam-logic-sketch_desc": "Ocena celotnega naslovljivega trga z logičnim razčlenjevanjem",
  "svc_risk-checklist_label": "Kontrolni seznam tveganj",
  "svc_risk-checklist_desc": "Celovit kontrolni seznam za oceno tveganj",
  "svc_feature-prioritization_label": "Prioritizacija funkcij",
  "svc_feature-prioritization_desc": "Priporočila za prioritizacijo na podlagi podatkov",
  "svc_next-research-question_label": "Naslednje raziskovalno vprašanje",
  "svc_next-research-question_desc": "Odkrijte naslednje ključno raziskovalno vprašanje",
  "svc_positioning-angle_label": "Strategija pozicioniranja",
  "svc_positioning-angle_desc": "Analiza pozicioniranja produkta in občinstva",
  "svc_blog-outline-trend_label": "Blog oris iz trenda",
  "svc_blog-outline-trend_desc": "Pretvorite trending teme v strukturirane blog orise",
  "admin_ai_reports": "Poročila AI storitev",
  "admin_project_delivery": "Dostava projekta",
  "admin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "sp_managed_hosting": "[TRANSLATE] Managed Hosting",
  "sp_enterprise_ad": "[TRANSLATE] Enterprise Advertising",
  "sp_email_marketing": "[TRANSLATE] Email Marketing Setup",
  "sp_competitor_analysis": "[TRANSLATE] Competitor Analysis Report",
  "sp_website_audit": "[TRANSLATE] Website Audit & SEO Report",
  "sp_managed_trading": "[TRANSLATE] Managed Trading",
  "sp_trading_consult": "[TRANSLATE] Trading Consultations",
  "sp_domains": "[TRANSLATE] LiveDomain Aftermarket",
  "sp_domain_mgmt": "[TRANSLATE] Domain Management",
  "sp_defi": "[TRANSLATE] DeFi Solutions",
  "sp_personal_brand": "[TRANSLATE] Personal Branding",
  "sp_ad_gen": "[TRANSLATE] Ad Generator",
  "sp_priority": "[TRANSLATE] Priority Queue",
  "sp_maintenance": "[TRANSLATE] Maintenance Plan",
  "sp_consulting": "[TRANSLATE] Smart Consulting Session",
  "sp_market_snapshot": "[TRANSLATE] Market Snapshot",
  "sp_trend_explainer": "[TRANSLATE] Trend Explainer",
  "sp_competitor_qa": "[TRANSLATE] Competitor Q&A",
  "sp_country_entry": "[TRANSLATE] Country Entry Check",
  "sp_vendor_shortlist": "[TRANSLATE] Vendor Shortlist Draft",
  "sp_tam_logic": "[TRANSLATE] Quick TAM Logic Sketch",
  "sp_positioning": "[TRANSLATE] Positioning Angle",
  "agency_rista_tooltip": "Klepet z RisTA",
  "agency_hero_title_1": "Bliskovito hitre spletne strani, ki ",
  "agency_hero_title_highlight": "prodajajo",
  "agency_hero_title_2": " za lokalna podjetja",
  "agency_hero_subtitle_1": "Pridobite prilagojeno stran, ki se naloži v milisekundah + vgrajena analitika za",
  "agency_hero_subtitle_2": ". Brez počasnih strani, več potencialnih strank — zagon v tednih.",
  "agency_hero_limited": "Omejeno število mest!",
  "agency_hero_cta_pricing": "Oglejte si paket za €498",
  "agency_hero_cta_audit": "Brezplačna revizija",
  "agency_trust_maintenance": "vzdrževanje po",
  "agency_trust_efficient": "100% Učinkovito",
  "agency_trust_powered": "Poganja Inteligentni Sistem",
  "agency_speed_title": "Hitrost nalaganja spletne strani",
  "agency_speed_before": "Prej",
  "agency_speed_after": "Potem",
  "agency_speed_leads": "+35% potencialnih strank",
  "agency_pain_title_1": "Počasne spletne strani ",
  "agency_pain_title_2": "ubijajo prodajo",
  "agency_pain_subtitle": "Vsaka sekunda nalaganja vaše strani pomeni izgubljene stranke. Tukaj je problem — in kako ga rešujemo.",
  "agency_pain_slow_title": "Počasno nalaganje = Izgubljene stranke",
  "agency_pain_slow_desc": "Vaša spletna stran se nalaga več kot 5 sekund. Obiskovalci odidejo, preden vidijo vašo ponudbo.",
  "agency_pain_stats_title": "47% odide pri >3s",
  "agency_pain_stats_desc": "Googlova raziskava kaže, da skoraj polovica obiskovalcev zapusti mobilno stran, ki se nalaga več kot 3 sekunde.",
  "agency_pain_stats_source": "Vir: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Naša Speed-First tehnologija",
  "agency_pain_solution_desc": "Prilagojene strani optimizirane za nalaganje pod 1 sekundo. Edge-cache, optimizirane slike, minimizirana koda.",
  "agency_pricing_title": "Enostavne, pregledne cene",
  "agency_pricing_subtitle": "Izberite načrt, ki ustreza vašemu podjetju. Vsi načrti vključujejo našo Speed-First tehnologijo.",
  "agency_pricing_urgency_1": "Samo še ",
  "agency_pricing_urgency_2": " začetnih mest ta mesec",
  "agency_pricing_popular": "NAJBOLJ PRILJUBLJENO",
  "agency_pricing_get_started": "Začnite",
  "agency_pricing_guarantee": "30-dnevna garancija vračila denarja",
  "agency_pricing_ideal": "Idealno za:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "enkratno",
  "agency_pricing_starter_ideal": "Samostojne podjetnike",
  "agency_pricing_s_1": "Bliskovito hitra prilagojena spletna stran",
  "agency_pricing_s_2": "Domena + gostovanje za 1 leto",
  "agency_pricing_s_3": "Osnovna analitična plošča",
  "agency_pricing_s_4": "Mobilno prilagojen dizajn",
  "agency_pricing_s_5": "SSL certifikat vključen",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Rastoče trgovine",
  "agency_pricing_p_1": "Vse iz paketa Starter",
  "agency_pricing_p_2": "E-trgovina + obnovitev košarice",
  "agency_pricing_p_3": "SEO optimizacijski paket",
  "agency_pricing_p_4": "A/B testiranje",
  "agency_pricing_p_5": "Prednostna podpora",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Rastoča podjetja",
  "agency_pricing_pr_1": "Vse iz paketa Performance",
  "agency_pricing_pr_2": "Upravljanje Google oglasov",
  "agency_pricing_pr_3": "Tedenske revizije zmogljivosti",
  "agency_pricing_pr_4": "Dodeljen skrbnik računa",
  "agency_pricing_pr_5": "Prilagojene integracije",
  "agency_social_title": "Zaupanje lokalnih podjetij",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Analiziram obnašanje obiskovalcev v realnem času za izboljšanje vaših konverzij.",
  "agency_social_see_clients": "Kaj pravijo naše stranke",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "Direktor, Lokalna trgovina",
  "agency_social_t1_text": "V prvem mesecu smo podvojili potencialne stranke! Spletna stran se naloži takoj in naše stranke obožujejo nov dizajn.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Lastnica restavracije",
  "agency_social_t2_text": "Naša spletna naročila so po zagonu narasla za 40%. Razlika v hitrosti je kot dan in noč.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Fitnes studio",
  "agency_social_t3_text": "Profesionalno, hitro in resnično držijo obljube. Naša stopnja rezervacij je narasla za 35% v samo 3 tednih.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Lastnica butika",
  "agency_social_t4_text": "Nastavitev e-trgovine je bila brezhibna. Samo obnovitev košarice je povrnila naložbo v plan Performance v prvem četrtletju.",
  "agency_social_metric_1": "Povpr. čas nalaganja",
  "agency_social_metric_2": "Več potencialnih strank",
  "agency_social_metric_3": "Zadovoljstvo strank",
  "agency_services_title": "Vse, kar vaše podjetje potrebuje",
  "agency_services_subtitle": "Celovite digitalne rešitve za rast vaše spletne prisotnosti.",
  "agency_svc_fast_title": "Hitre spletne strani",
  "agency_svc_fast_desc": "Prilagojene strani, ki se naložijo v manj kot 1 sekundi. Mobile-first, SEO optimizirane.",
  "agency_svc_ecom_title": "E-Commerce trgovine",
  "agency_svc_ecom_desc": "Prodajajte na spletu z obnovitvijo košarice, obdelavo plačil in upravljanjem zalog.",
  "agency_svc_seo_title": "SEO revizija in optimizacija",
  "agency_svc_seo_desc": "Uvrstite se višje na Googlu. Tehnični SEO, strategija vsebin in mesečna poročila.",
  "agency_svc_ads_title": "Nastavitev Google oglasov",
  "agency_svc_ads_desc": "Hitro pridobite ciljni promet. Nastavitev kampanje, optimizacija in sledenje ROI vključeno.",
  "agency_svc_maint_title": "Vzdrževanje in podpora",
  "agency_svc_maint_desc": "Gostovanje, varnostne posodobitve, varnostne kopije in spremembe vsebine. Od €30/mesec.",
  "agency_faq_title": "Pogosto zastavljena vprašanja",
  "agency_faq_q1": "Kako hitro se bo moja spletna stran naložila?",
  "agency_faq_a1": "Pod 1 sekundo. Optimiziramo vsako milisekundo — od odziva strežnika do popolnega vizualnega prikaza.",
  "agency_faq_q2": "Kaj je vključeno v paket Starter za €498?",
  "agency_faq_a2": "Bliskovito hitra prilagojena spletna stran, domena in gostovanje za 1 leto, osnovna analitična plošča, odziven dizajn in SSL certifikat.",
  "agency_faq_q3": "Koliko časa traja do zagona?",
  "agency_faq_a3": "Večina projektov Starter se zažene v 2-3 tednih. Načrti Performance in Premium običajno trajajo 4-6 tednov.",
  "agency_faq_q4": "Ali nudite stalno vzdrževanje?",
  "agency_faq_a4": "Da. Po prvem letu se vzdrževanje začne pri €30/mesec, vključno z gostovanjem, varnostnimi posodobitvami in manjšimi spremembami.",
  "agency_faq_q5": "Ali lahko pozneje nadgradim svoj načrt?",
  "agency_faq_a5": "Seveda. Kadarkoli lahko nadgradite iz Starter na Performance ali Premium. Vašo začetno naložbo bomo upoštevali.",
  "agency_cta_title_1": "Pripravljeni na rast ",
  "agency_cta_title_2": "brez omejitev?",
  "agency_cta_subtitle": "Povejte nam o svojem podjetju in ustvarili bomo prilagojen načrt. Brezplačno svetovanje, brez obveznosti.",
  "agency_contact_name": "Vaše ime",
  "agency_contact_email": "E-poštni naslov",
  "agency_contact_biz_select": "Izberite vrsto podjetja",
  "agency_contact_biz_restaurant": "Restavracija / Hrana",
  "agency_contact_biz_retail": "Trgovina na drobno",
  "agency_contact_biz_services": "Profesionalne storitve",
  "agency_contact_biz_fitness": "Fitnes / Wellness",
  "agency_contact_biz_realestate": "Nepremičnine",
  "agency_contact_biz_other": "Drugo",
  "agency_contact_submit": "Brezplačno svetovanje",
  "agency_contact_sent_title": "Sporočilo poslano!",
  "agency_contact_sent_desc": "Odgovorili vam bomo v 24 urah.",
  "agency_exit_title": "Počakajte! Brezplačna revizija hitrosti?",
  "agency_exit_desc": "Ugotovite, koliko hitrejša bi lahko bila vaša spletna stran. Podrobno poročilo — 100% brezplačno.",
  "agency_exit_email": "Vaš email",
  "agency_exit_submit": "Pošlji revizijo",
  "agency_exit_thanks_title": "Hvala!",
  "agency_exit_thanks_desc": "Brezplačno revizijo hitrosti vam bomo poslali v 24 urah.",
  "agency_footer_brand_desc": "Razvito, gostovano in zasnovano s strani Infinitybusiness.org",
  "agency_footer_services": "Storitve",
  "agency_footer_fast_web": "Hitre spletne strani",
  "agency_footer_ecom": "E-Commerce trgovine",
  "agency_footer_seo": "SEO revizija",
  "agency_footer_ads": "Nastavitev Google oglasov",
  "agency_footer_maint": "Vzdrževanje",
  "agency_footer_company": "Podjetje",
  "agency_footer_about": "O nas",
  "agency_footer_contact": "Kontakt",
  "agency_footer_privacy": "Politika zasebnosti",
  "agency_footer_terms": "Pogoji uporabe",
  "agency_footer_touch": "Stopite v stik",
  "agency_footer_copyright": "© 2026 Infinity Business. Vse pravice pridržane.",
  "agency_footer_dev_by": "Razvito, gostovano in zasnovano s strani",
  "agency_footer_newsletter": "Naročite se na novice",
  "agency_footer_subscribe": "Naročite se",
  "agency_sticky_pricing": "Oglejte si cene",
  "showroom_page_title": "Razstavni prostor",
  "showroom_meta_desc": "Raziščite naš portfelj preobrazb spletnih strani. Primerjave pred in po dejanskih projektih strank.",
  "showroom_badge": "Naše Delo",
  "showroom_title_prefix": "Projektni",
  "showroom_title_highlight": "Razstavni Prostor",
  "showroom_subtitle": "Oglejte si dejanske preobrazbe. Povlecite drsnik za primerjavo stanja pred in po naših projektih strank.",
  "showroom_search_placeholder": "Išči projekte...",
  "showroom_all_services": "Vse Storitve",
  "showroom_sort_newest": "Najnovejše najprej",
  "showroom_sort_oldest": "Najstarejše najprej",
  "showroom_sort_name_az": "Ime A-Ž",
  "showroom_sort_name_za": "Ime Ž-A",
  "showroom_active_filters": "Aktivni filtri",
  "showroom_showing": "Prikazano",
  "showroom_project_singular": "projekt",
  "showroom_project_plural": "projektov",
  "showroom_empty": "V razstavnem prostoru še ni projektov.",
  "showroom_no_match": "Noben projekt ne ustreza vašim filtrom.",
  "showroom_features_built": "Zgrajene Funkcionalnosti",
  "showroom_visit_live": "Obiščite Stran"
};
